import { OPEN_STATUS } from "@/enums/open-status-type";
import {
  FACILITY_STATUS,
  BING_FACILITY_STATUS
} from "@/enums/facility-status-type";
import { WEEK_DAYS } from "@/enums/week-days";
import {
  POST_TYPE,
  POSTS_FORM_TYPE,
  POSTS_CALL_TO_ACTION_TYPE,
  POST_BY_FACILITY_STATUS
} from "@/enums/posts.enum";
import { FACILITY_CREATE_ACTION } from "@/enums/gmb-search-type";
import { FACILITIES_SORTING_OPTION } from "@/enums/facilities-sorting-option";
import {
  PERIODIC_REPORT_TYPE,
  TOP_CHART_SERIE
} from "@/enums/charts-type.enum";
import { AccountType } from "@/enums/account-type";

import {
  EXTERNAL_CHANGES_SOURCE,
  EXTERNAL_CHANGES_TYPE,
  EXTERNAL_CHANGES_STATUS,
  EXTERNAL_CHANGES_FIELD
} from "@/enums/external-changes";
import { KEYWORDS_SCOPE } from "@/enums/keywords";
import { DIALOG_MANAGE_MODE } from "@/enums/reply-templates";
import { REVIEWS_TAGS_SEARCH_TYPE } from "@/enums/reviews.enum";
import { Module } from "@/enums/modules";
import { GMB_MEDIA_STATUS } from "@/enums/gmb-media-status";
import { GMB_MEDIA_TYPE } from "@/enums/gmb-media-type";

export default {
  common: {
    setPasswordAndFinishRegistration:
      "Establecer contraseña y finalizar registro",
    page: "Página {0}",
    readMore: "Leer más",
    expand: "Expandir",
    collapse: "Contraer",
    locations: "Ubicaciones",
    members: "Usuarios",
    keywords: "Palabras clave",
    tags: "Revisar categorías",
    competitors: "Ubicación del competidor",
    yourFacility: "Tu ubicación",
    competitorsFacility: "Ubicación del competidor",
    deleteSelected: "Eliminar seleccionado",
    learnMore: "Aprende más",
    name: "Nombre",
    stats: "Estadísticas",
    videoTutorialsTooltip: "Mira el video que presenta esta funcionalidad.",
    faq: "Ayuda",
    selectImportColumns: "Seleccione las columnas que desea importar.",
    upload: "Subir",
    addFile: "Agregar archivo",
    desktop: "escritorio",
    exportToCSV: "Exportar a CSV",
    exportCSV: "Exportar CSV",
    exportToFile: "Exportar a archivo",
    mobile: "móvil",
    select: "Seleccionar",
    edited: "Editado",
    downloadStarted: "Descarga iniciada",
    groups: "Grupos",
    range: "Rango",
    selectAddress: "Seleccionar dirección",
    dontShowItAgain: "No mostrar de nuevo",
    changeName: "Cambiar nombre",
    show: "Mostrar {0}",
    bestPractices: "Mejores prácticas",
    dataProcessing: "Procesamiento de datos en curso",
    points: "pts",
    above: "Arriba",

    allReviews: "Todas las reseñas",
    reviewsWithoutCategory: "Reseñas sin categorías",
    accept: "Aceptar",
    accessibility: "Accesibilidad",
    accountData: "Datos de la cuenta",
    accountSettings: "Configuración de la cuenta",
    accountAdded: "Cuenta añadida",
    accountDeleted: "Cuenta eliminada",
    accountType: "Tipo de cuenta",
    actions: "Acciones",
    addDomain: "Agregar dominio",
    add: "Agregar",
    addAccount: "Agregar cuenta",
    addBusinessAddress: "Agregar ubicación",
    addFacility: "Agregar ubicación",
    addFbId: "Agregar ID de página",
    addManually: "Agregar manualmente",
    addMonitoredKeywords: "Agregar palabras clave para el monitoreo",
    addNew: "Agregar nuevo",
    addNewTerm: "Agregar palabra clave",
    addOwnBusinessAddress: "Añadir ubicación propia del negocio",
    addProfile: "Agregar perfil",
    addProfileName: "Agregar nombre de perfil",
    additionalCategories: "Categorías comerciales adicionales",
    address: "Dirección",
    addUrlAddress: "Agregar URL",
    urlAddress: "Dirección URL",
    after: "Después",
    analytics: "Analítica",
    comparator: "Compara las listas de Google Maps",
    appliance: "Dispositivo",
    apply: "Aplicar",
    all: "Todo",
    allFacilities: "Todas las ubicaciones comerciales",
    more: "Más",
    less: "Menos",
    added: "Añadido",
    assignAccount: "Asignar cuenta",
    avg_rate_on_main_page:
      "Calificación promedio en las reseñas más relevantes",
    accurate_number_of_photos: "Fotos",
    ascending: "Ascendente",
    automatically: "Automáticamente",
    back: "Atrás",
    backToList: "Volver a la lista",
    backToSignIn: "Volver a iniciar sesión",
    before: "Antes de",
    businessAddress: "Dirección de la empresa",
    businessAddresses: "Ubicaciones",
    businessAddressesGroups: "Grupos de ubicaciones",
    businessAddressesList: "Lista de ubicaciones",
    businessAddressOrWww: "Ubicación o sitio web",
    billingData: "Datos de facturación",
    by: "por",
    cancel: "Cancelar",
    categories: "Categorías",
    category: "Categoría",
    change: "Cambiar",
    changeAccountType: "Cambiar tipo de cuenta",
    changeSinceLastWeek: "Cambios desde la semana pasada",
    choose: "Elegir",
    chooseDate: "Elige franja horaria",
    chooseGmbAccount: "Elige una cuenta de Google",
    choosePeriod: "Elegir rango",
    chooseProfile: "Elegir perfil",
    chosenBusinessAddress: "Ubicación elegida",
    city: "Ciudad",
    clear: "Claro",
    clients_activity_score: "Hoja de actividad del cliente",
    close: "Cerrar",
    closed: "Cerrado",
    collectData: "Recopilación de datos",
    companyName: "Nombre del negocio en el panel de Center AI",
    legalCompanyName: "Nombre de la empresa",
    taxNumber: "Número de identificación fiscal (NIF)",
    companyProfile: "Configuración",
    compareWith: "Comparar con",
    competition: "Competidores",
    competitionVisibility: "Comparación con la competencia",
    competitiveBusinessAddresses: "Ubicaciones de competidores",
    competitiveWebsites: "Sitios web de la competencia",
    confirm: "Confirmar",
    confirmDelete: "Sí, eliminar",
    confirmPassword: "Confirmar contraseña",
    consentsAndRegulations: "Consentimientos y Términos de Uso",
    contact: "Detalles de contacto",
    contactPhone: "Teléfono móvil",
    contactWithUs: "Contáctanos",
    content: "Contenido",
    continue: "Continuar",
    country: "País",
    cover_photo: "Foto de portada",
    createAccount: "Crear una cuenta",
    createBusinessAddress: "Crear ubicación",
    currentData: "Datos actuales",
    dashboard: "Panel de control",
    day: "Día",
    dateFrom: "Fecha desde",
    dateTo: "Fecha para",
    dateRange: "Rango de fechas",
    delete: "Eliminar",
    deletePicked: "Eliminar seleccionado",
    descending: "Descendiendo",
    description: "Descripción",
    details: "Detalles",
    seeDetails: "Ver detalles",
    direction: "Dirección",
    doYouWantToSaveChanges: "¿Te gustaría guardar los cambios?",
    monday: "Lunes",
    tuesday: "Martes",
    wednesday: "Miércoles",
    thursday: "Jueves",
    friday: "viernes",
    saturday: "sábado",
    sunday: "Domingo",
    edit: "Editar",
    editFromFile: "Editar desde archivo",
    editData: "Editar datos",
    email: "Correo electrónico",
    emailAddress: "Dirección de correo electrónico",
    exportTo: "Exportar a:",
    exportTo2: "Exportar a",
    exportGroupedByDates: "agrupados por fechas",
    exportGroupedByLocations: "agrupado por ubicaciones",
    facility: "Ubicación",
    facilityData: "Datos de ubicación",
    facilityName: "nombre de la ubicación",
    fillYourCompanyData: "Complete los datos de su empresa",
    filter: "Filtrar",
    filters: "Filtros",
    find: "Buscar en",
    findCity: "Buscar ciudad",
    findPhrase: "Encontrar frase",
    findFacility: "Buscar ubicación",
    followers: "Seguido por",
    following: "Siguiendo",
    forgotPassword: "Olvidé mi contraseña",
    from: "Desde",
    further: "Siguiente",
    importedBusinessAddresses: "Ubicaciones importadas",
    importFacilities: "Importar ubicaciones",
    facilitiesCountIsOwnerTooltip:
      "Ubicaciones importadas de Google Business Profile Manager. Puedes editar estas ubicaciones.",
    facilitiesCountIsNotOwnerTooltip:
      "Ubicaciones agregadas desde fuera del Administrador de Perfiles de Empresa de Google. No puedes editar estas ubicaciones.",
    facilityOpenStatus: "Estado de apertura",
    importStatus: "Estado de importación",
    openStatusLabel: {
      all: "Todo",
      open: "Abrir",
      closedPermanently: "Cerrado permanentemente",
      closedTemporarily: "Cerrado temporalmente"
    },
    importStatusLabel: {
      any: "Cualquiera",
      imported: "Importado",
      notImported: "No importado"
    },
    validation: {
      urlWithProtocol: "La URL debe comenzar con http:// o https://",
      requiredField: "Este campo es obligatorio",
      maxLength: "La longitud máxima es de {0} caracteres",
      minLength: "La longitud mínima es de {0} caracteres",
      minWords: "El número mínimo de palabras es {0}"
    },
    facilitiesStatus: "Estado de ubicaciones",
    facilitiesStatusInGoogleMaps: "Estado de ubicaciones en Google Maps",
    facilitiesStatusInBingMaps: "Estado de ubicaciones en Bing Maps",
    facilityIsOwnerTooltip:
      "Ubicación importada desde Google Business Profile Manager. Puedes editar esta ubicación.",
    facilityIsNotOwnerTooltip:
      "Ubicación agregada desde fuera de Google Business Profile Manager. No puedes editar esta ubicación.",
    freeTrialInfo:
      "Prueba Center AI gratis durante {0} días, sin necesidad de tarjeta de crédito. No se te cobrará nada a menos que decidas elegir un plan después de tu prueba.",
    freeTrialTitle: "¡Vamos a configurarlo!",
    general: "Principal",
    generalData: "Datos generales",
    gmb_analytics: "Analítica",
    googleMaps: "Google Maps",
    facebook: "Facebook",
    googleMyBusiness: "Google Business Profile Manager",
    govTaxNumber: "VAT ID",
    history: "Historia",
    importPicked: "Importar seleccionado",
    institution: "Ubicación",
    lack: "Nada",
    lastAudit: "Última auditoría",
    likes: "Likes",
    list: "Lista",
    loadingTime: "Tiempo de carga",
    location: "Localidad",
    login: "Iniciar sesión",
    logOut: "Cerrar sesión",
    manage: "Gestionar",
    maps: "Mapas",
    marketingConsents: "Consentimientos de marketing",
    mobileAdaptation: "Adaptación móvil",
    month: "Mes",
    moreInformations: "Más",
    moreThan: "Arriba",
    newLocality: "Nueva localidad",
    newLocation: "Nueva localidad",
    newPassword: "Nueva contraseña",
    newTerm: "Nueva palabra clave",
    newWebsite: "Nuevo sitio web",
    next: "Siguiente",
    noData: "Sin datos",
    noDataDescription:
      "Actualmente estamos recopilando datos. La información estará disponible aquí en unas pocas horas.",
    noChanges: "Sin cambios",
    none: "Ninguno",
    noRatings: "Sin calificaciones",
    number_of_photos: "Número de fotos",
    number_of_posts: "Número de publicaciones",
    ofPages: "fuera de",
    ok: "OK",
    oldPassword: "Contraseña anterior",
    open: "Abrir",
    open_hours: "Horario de apertura",
    openCloseFacilities: "Apertura y cierre de ubicaciones",
    openCloseFacility: "Horario de apertura y cierre de la ubicación",
    openStreetMap: "Mapa Abierta de Calles",
    optional: "Opcional",
    or: "o",
    other: "Otro",
    overview: "Descripción general",
    password: "Contraseña",
    performance: "Rendimiento",
    perPage: "Elementos por página",
    phone_number: "Número de teléfono",
    photos: "Fotos",
    pickFacilities: "Elige ubicaciones",
    pickWebsite: "Elegir sitio web",
    pointer: "Elemento",
    pointers: "Apuntadores",
    poland: "Polonia",
    position: "posición",
    positionsCount: "Posiciones: {0}",
    positionAbove: "Fuera del top {0}",
    postalCode: "Código postal",
    postcode: "Código postal",
    posts: "Publicaciones",
    postsAdd: "Agregar publicación",
    postsEdit: "Editar publicación",
    postsList: "Publicaciones",
    previewPhoto: "Vista previa de fotos",
    previous: "Anterior",
    primaryCategory: "Categoría principal de negocio",
    profile_photo: "Foto de perfil",
    profileDeleted: "Perfil eliminado",
    provideCode: "Ingrese el código",
    quarter: "Trimestre",
    rate: "Clasificación",
    rateCenter: "Center AI Calificación",
    refresh: "Actualizar",
    reject: "Rechazar",
    rememberMe: "Recuérdame",
    removeAccount: "Eliminar desde Center AI",
    removeFacility: "Eliminar ubicación",
    removeFacilities: "Eliminar ubicaciones",
    removeFilters: "Eliminar filtros",
    removeProfile: "Eliminar de Center AI",
    repeatNewPassword: "Repite la nueva contraseña",
    report: "Informe",
    reportProblem: "Informar de un problema",
    resend: "Reenviar",
    resetPassword: "Restablecer la contraseña",
    reviewers: "Total de reseñas",
    reviews_rating: "Calificación media",
    reviews: "Calificación en Google Maps",
    save: "Guardar",
    saveData: "Guardar datos",
    savedDoneChanges: "Guardar cambios en",
    facilities: "ubicaciones",
    search: "Buscar",
    searchCompany: "Empresa de búsqueda",
    searchEngines: "Motores de búsqueda",
    searchTerm: "Buscar palabra clave",
    searchTerms: "Palabras clave monitoreadas",
    security: "Seguridad",
    selectAll: "Seleccionar todo",
    selectAllFromPage: "Seleccionar todo en la página",
    selectedCount: "Seleccionado: {0}",
    sendEmail: "Enviar correo electrónico",
    seo: "Seo",
    settings: "Configuración",
    showHistory: "Mostrar historial",
    showFacility: "Mostrar detalles",
    signUp: "Registrarse",
    signUpTrial: "Pruébalo gratis",
    signUpTitle:
      "Cuida de tu visibilidad local y reputación empresarial. Gana clientes leales y haz crecer tu negocio.",
    signUpTrialTitle:
      "Regístrate hoy y disfruta de {0} días del plan Estándar – <b>sin necesidad de tarjeta de crédito</b>. ¡Descubre cómo Center AI puede ayudarte a atraer más clientes locales!",
    skip: "Saltar",
    social: "Comunidad",
    socialMedia: "Redes sociales",
    sort: "Ordenar",
    sortBy: "Ordenar por",
    speed: "Velocidad",
    status: "Estado",
    date: "Fecha",
    hour: "Hora",
    statusOnGoogleMaps: "Estado de Google Maps",
    statusOnGMB: "Estado del Administrador de Perfiles de Negocios de Google",
    storeCode: "Código de la tienda",
    street: "Calle",
    subscription: "Suscripción",
    suggested: "Sugerido",
    summary: "Resumen",
    tasksToDo: "Lista de tareas",
    termsOfService: "Política de Privacidad",
    trade: "Categoría de negocios",
    tryAgain: "Inténtalo de nuevo.",
    to: "a",
    urlAttribute: "atributo URL",
    user_activity_score: "Tu actividad",
    userAccount: "Cuenta de usuario",
    userName: "Nombre de usuario",
    userProfile: "Perfil de usuario",
    voivodeship: "Región",
    website: "Sitio web",
    websites: "Sitios web",
    week: "Semana",
    www_analytics: "Analítica de sitios web",
    year: "Año",
    yourBusinessAddress: "Dirección de ubicación",
    yourBusinessAddresses: "Tus ubicaciones",
    yourCompany: "Tu empresa",
    yourPosition: "Tu posición",
    yourPositionOnGoogleMaps:
      "Tu posición en los resultados de búsqueda de Google Maps",
    yourSite: "Tu sitio",
    yourVisibility: "Tu visibilidad",
    yourWebsite: "Tu sitio web",
    yourWebsites: "Tus sitios web",
    csv: "CSV",
    xls: "XLS",
    xlsx: "XLSX",
    yes: "Sí",
    no: "No",
    see: "Ver más",
    copiedToClipboard: "Copiado al portapapeles",
    filterByDateOf: "Filtrar por fecha de",
    reviewLastEdit: "Última edición",
    reviewCreation: "Creación",
    reviewLastEditOrCreation: "Última edición o creación"
  },

  pluralForms: {
    facility: ["ubicación", "ubicaciones", "ubicaciones"],
    facilityGenitive: ["ubicación", "ubicaciones", "ubicaciones"],
    facilityLocative: ["ubicación", "ubicaciones", "ubicaciones"],
    city: ["ciudad", "ciudades", "ciudades"],
    group: ["grupo", "grupos", "grupos"],
    groupGenitive: ["grupo", "grupos", "grupos"],
    review: ["reseña", "reseñas", "reseñas"],
    position: ["posición", "posiciones", "posiciones"],
    click: ["clic", "clics", "clics"],
    view: ["ver", "vistas", "vistas"],
    changeAccusative: ["cambio", "cambios", "cambios"]
  },

  serviceUnavailable: {
    title: "Mantenimiento del sistema",
    description:
      "Lo sentimos, el panel web y la API de Center AI están actualmente no disponibles debido a trabajos de mantenimiento planificados. La disponibilidad del sistema se restablecerá pronto.",
    footer: "Gracias por tu comprensión,",
    signature: "Equipo de <span style='color: #4a24ac'>Center AI</span>",
    backToMainPage: "Volver a la página principal"
  },

  service: {
    accountSuspended:
      'Lamentamos informarte que tu cuenta de <a href="https://center.ai/" target="_blank">Center AI</a> ha sido suspendida temporalmente debido a un problema de pago pendiente. Para restablecer la funcionalidad completa de tu cuenta y seguir utilizando nuestra solución, te pedimos amablemente que resuelvas el saldo vencido. Si tienes alguna pregunta o inquietud, por favor comunícate con nuestro Equipo de Atención al Cliente en <a href="mailto:support@center.ai">support@center.ai</a>.',
    subscriptionPlanExpired:
      "Tu plan de suscripción ha expirado. Para renovar tu suscripción, por favor ve a configuración.",
    wrongSubscriptionPlan:
      "Tu plan de suscripción no permite realizar esta acción.",
    subscriptionLimit:
      "Se ha superado el número de ubicaciones permitidas. Su plan de suscripción solo permite X ubicaciones. Contáctenos si desea aumentar su cuota de ubicaciones."
  },

  dashboard: {
    clientScoreHistory: "Tu cronología de reseñas de Google Maps",
    lastMonth: "a partir del mes pasado",
    googleMaps: "Visibilidad de Google Maps",
    googleMyBusiness: "Calidad de ubicaciones en Google Maps",
    fromLastWeek: "a partir de la semana pasada",
    fromLastMonth: "desde el mes pasado",
    fromLast30Days: "en los últimos 30 días",
    selectAll: "Seleccionar todo",
    noDataFromLastMonth: "No hay datos para el mes pasado.",
    competitionBusiness: "Competidores",
    visibility: "Visibilidad",
    quality: "Calidad",

    checkbox: {
      overallRate: "Calificación general",
      googleOrganic: "Visibilidad de los resultados de búsqueda de Google",
      googleMaps: "Visibilidad en Google Maps",
      googleMyBusiness: "Calidad de las ubicaciones de Google Maps",
      websites: "Calidad del sitio web",
      socialMedia: "Calidad de los perfiles de redes sociales",
      otherMaps: "Visibilidad de otros mapas"
    },

    title: "¡Bienvenido de nuevo!",
    daysRange: "Últimos {0} días",
    widgetTitle: {
      averageRating: "Calificación promedio",
      ratingCount: "Número de reseñas",
      repliesPercentage: "% de reseñas respondidas",
      ratingDistribution: "Distribución de calificaciones",
      bestGmbAddresses: "Mejor valoradas ubicaciones",
      worstGmbAddresses: "Lugares con las calificaciones más bajas",
      lowestQualityGmbAddresses:
        "Ubicaciones con la calidad más baja en Google Maps",
      postsCount: "Publicaciones añadidas",
      viewsCount: "Vistas de ubicaciones",
      queriesCount: "Búsquedas de ubicaciones",
      queries: "Tipos de consultas de búsqueda",
      actionsDrivingDirections: 'Acciones de "Solicitar direcciones"',
      actionsWebsite: 'Acciones de "Visitar sitio web"',
      actionsPhone: 'Acciones de "Llamada telefónica"'
    },
    widgetTooltip: {
      comparedToLast30Days: "En comparación con los 30 días anteriores",
      averageRating: "Calificación promedio",
      ratingCount: "Número de valoraciones",
      repliesPercentage: "% opiniones respondidas",
      ratingDistribution: "Distribución de calificaciones",
      bestGmbAddresses: "Ubicaciones mejor valoradas",
      worstGmbAddresses: "Lugares con la calificación más baja",
      lowestQualityGmbAddresses:
        "Ubicaciones con la calidad más baja en Google Maps",
      postsCount: "Publicaciones añadidas",
      viewsCount: "Vistas de ubicaciones",
      queriesCount: "Búsquedas de ubicaciones",
      queries: "Tipos de consultas",
      actionsDrivingDirections: '"Solicitar direcciones" acciones',
      actionsWebsite: 'Acciones de "Visitar sitio web"',
      actionsPhone: 'Acciones de "Llamadas telefónicas"'
    },
    ratingDistributionSerie: 'Calificación "{0}"',
    addressScore: "Calidad {0}/100",
    queriesSerie: {
      direct: "Búsquedas directas",
      indirect: "Búsquedas de descubrimiento",
      chain: "Búsquedas de marcas"
    }
  },

  tooltip: {
    indicator: "Haz clic para más detalles"
  },

  session: {
    accountTypeSelection: {
      employee: "Empleado",
      company: "Compañía",
      ifHaveAnAccount: "o si tienes una cuenta",
      signUpAs: "Regístrate como",
      companyOwnerText: `Soy administrador o propietario de una empresa. Quiero crear una cuenta para mi organización.`,
      employeeText: `Ya usamos Center AI en la empresa. Quiero acceder a la aplicación.`
    },
    employeePage: {
      title: "Registro de empleados",
      description1: `Si tu empresa ya utiliza Center AI, deberías recibir una invitación en tu dirección de correo electrónico.`,
      description2: `Si no has recibido una invitación, pídele a tu administrador que te envíe la invitación.`,
      ifHaveAnAccount: "... o si ya tienes una cuenta"
    },
    dontHaveAccount: "¿Todavía no tienes una cuenta?",
    haveAccount: "¿Ya tienes una cuenta en Center AI?",
    loginWithFacebook: "Iniciar sesión con Facebook",
    loginWithGoogle: "Iniciar sesión con Google",
    signUpWithFacebook: "Regístrate con Facebook",
    signUpWithGoogle: "Regístrate con Google",

    login: {
      description:
        "Introduce tu correo electrónico y contraseña para iniciar sesión en el panel."
    },

    forgot: {
      description:
        "Por favor, introduce tu correo electrónico para recibir un enlace para restablecer la contraseña."
    },

    reset: {
      description: "Confirmar contraseña"
    },

    register: {
      privacyPolicy: "Política de Privacidad",
      regulations: "Términos de Uso",
      bySigningUpYouAgreeTo:
        "Al registrarte, confirmas que has leído y aceptado la {privacyPolicy} y los {regulations}.",
      consent_3:
        "Quiero recibir boletines informativos y correos electrónicos de marketing (puedes cambiar esto en cualquier momento)."
    },

    agreement: {
      newsletterAndMarketing:
        "Me gustaría suscribirme al boletín y al marketing por correo electrónico (puede revocar su consentimiento en cualquier momento)."
    }
  },

  notification: {
    userLoggedInSuccess: "¡Inicio de sesión del usuario exitoso!",
    activationCodeWasAdded: "El código de activación ha sido añadido.",
    changesSaved: "Cambios guardados exitosamente",
    activationCodeWasNotAdded:
      "Este código de activación no se puede usar. Ya no es válido o pertenece a un plan de suscripción menos completo.",
    noCompetitionAdded:
      "No se añadieron ni seleccionaron competidores para la comparación."
  },

  visibility: {
    summary: {
      businessAddressesTitle: "Visibilidad en Google Maps",
      websitesTitle: "Visibilidad en los resultados de búsqueda de Google",
      noBusinessAddressesInfo:
        "Al agregar la dirección comercial de un lugar determinado, puedes ver el mapa que muestra la clasificación de tu empresa en las búsquedas de Google.",
      noKeywordsInfo:
        "Para cada palabra clave añadida, Center AI supervisará la posición de tus listados en la búsqueda de Google Maps. Para añadir palabras clave, primero necesitas añadir listados a Center AI.",
      noWebsiteAddress: "No hay dirección de sitio web",
      noWebsiteAddressInfo:
        "Al agregar la dirección de tu propio sitio web, puedes conocer tu clasificación actual.",
      dataCollectionPendingForKeyword:
        "Los datos para esta palabra clave se están preparando.",
      dataCollectionForKeywordTryAgainLater:
        "¡Los radares de Center AI ya están operativos! Actualmente estamos recopilando datos.",
      addKeywords: "Agregar palabras clave de búsqueda.",

      map: {
        info:
          "Este mapa muestra la posición de tu <b>ubicación</b> en Google Maps basada en la palabra clave específica y la ubicación del usuario. Los colores indican la fuerza de tu listado en una determinada área. Por ejemplo, el color verde significa el más fuerte (más cerca del no. 1), mientras que el rojo representa el más débil entre los principales 20 (más cerca del no. 20), y el gris significa fuera de los principales 20.",
        subtitle: "La posición de tu ubicación en Google Maps",
        legend: {
          high: "Alto",
          medium: "Medio",
          low: "Pobre",
          info:
            "La posición de tu ubicación en los resultados de búsqueda de Google Maps según una palabra clave elegida:",
          nodata: "Sin datos disponibles"
        }
      },

      chart: {
        title: "Posición promedio de la ubicación dentro de sus alrededores.",
        description:
          "El gráfico a continuación muestra la posición promedio de tu ubicación en un área determinada."
      },

      websites: {
        label: {
          yourWebsiteAddress: "Tu sitio web",
          localization: "Ubicación",
          competitionWebsiteAddress: "Sitio web de la competencia"
        },

        chart: {
          yAxisLabel: "Posición en los resultados de búsqueda de Google"
        },
        subtitle:
          "La posición de tu sitio web en los motores de búsqueda de Google en respuesta a una palabra clave determinada"
      }
    },

    GMBSummary: {
      history: {
        select: {
          centerRate: "Calificación de Center AI",
          googleMapsRate: "Calificación de Google Maps",
          googleMapsRatingQty: "Número de calificaciones de Google Maps",
          profileCompletness: "Integridad del Perfil"
        }
      },
      rate:
        "Center AI rating (0-100) - Calificación general para el perfil de Google Maps de tu ubicación. La calificación se basa en la completitud de tu perfil, las calificaciones de los clientes y la actividad de los clientes (nuevas calificaciones y reseñas).",
      avgRateInfo:
        "Las reseñas más relevantes son aquellas que Google destaca y muestra en la página principal de tu lista en Google Maps. Estas son las reseñas que tus clientes ven primero."
    },

    mapsVisibility: {
      title: "Tus ubicaciones en otros mapas",
      tooltip: {
        bing:
          "Microsoft Bing Maps. Uno de los servicios de mapas en línea más populares.",
        openStreetMap:
          "Estos mapas son un proyecto comunitario, se pueden utilizar de forma gratuita y las ubicaciones se pueden editar libremente. Esto los hace extremadamente populares y ampliamente utilizados para fines comerciales. Por ejemplo, Yanosik y JakDojadę están entre sus usuarios en Polonia.",
        targeo:
          "Estos mapas polacos son uno de los mapas más precisos del mercado. Automapa, un popular servicio de GPS, utiliza esos mapas.",
        yanosik:
          "Este es un servicio de alerta de carreteras gestionado por y para conductores. Ayuda a más de 1.5 millones de conductores cada mes en Polonia.",
        jakDojade:
          "Este es el planificador de viajes de transporte público favorito de Polonia, utilizado por 3.5 millones de pasajeros cada mes. Opera en más de 45 ciudades polacas. En particular, los estudiantes y los jóvenes adultos parecen preferirlo.",
        automapa:
          "Es uno de los servicios de GPS más populares de Polonia. Utilizado y valorado por muchos conductores."
      }
    }
  },

  competition: {
    header: "Sitios web de la competencia",
    businessAddresses: {
      title: "Los listados de tu competidor",
      noSuggested: "No se sugieren ubicaciones de competidores",
      suggestedTooltip:
        "Ubicaciones que han sido listadas en los resultados de búsqueda para tus palabras clave",
      label: {
        yourBusinessAddress: "Dirección de ubicación",
        addCompetitionBusinessAddress: "Agregar la ubicación del competidor"
      },
      noData:
        "Para agregar una empresa competidora, escribe el nombre de su empresa o ciudad o elige de las listas de competidores sugeridas a continuación."
    },
    visibility: {
      businessAddresses: {
        chartTitle:
          "Posición promedio de ubicación y posición de los competidores en la vecindad inmediata",
        chartDescription:
          "El gráfico a continuación muestra la posición promedio de tu ubicación en comparación con los competidores seleccionados.",
        cardTitle:
          "Descubre quién está en la cima de los resultados de búsqueda en tu área.",
        cardDescription:
          "Elige tu ubicación y marca hasta 5 ubicaciones de tus competidores.",
        cardInfo:
          "Los colores en el mapa representan las ubicaciones de los negocios e indican qué ubicación ocupa el puesto más alto en los resultados de búsqueda de Google Maps (entre las ubicaciones seleccionadas) para la palabra clave elegida, dependiendo de dónde se encuentre el cliente. Por ejemplo, el color naranja muestra dónde alguien que busca un producto o servicio específico ve tu ubicación en el puesto más alto.",
        inputLegend: "La ubicación de tu negocio en el mapa",
        listTitle: "Ubicaciones de los competidores",
        listNoData: "No se enumeran las ubicaciones de los competidores",
        searchingData:
          "Actualmente estamos procesando tu consulta sobre la palabra clave seleccionada.",
        addNewTerm:
          "Añadir palabras clave. Las palabras clave más populares aparecerán aquí."
      },
      title: "Visibilidad de los competidores en Google y Google Maps",
      keywordsTitle: "Palabras clave monitoreadas",
      nodata: {
        title: "No se ha enumerado la dirección del sitio web.",
        content:
          "Al agregar la dirección de tu propio sitio web, puedes conocer la posición actual de tus competidores."
      }
    }
  },

  analytics: {
    wellDone: "Bien hecho",
    needFix: "Necesita mejoras",
    scale: {
      great: "Genial",
      good: "Bueno",
      medium: "Promedio",
      weak: "Débil"
    },

    businessAddresses: {
      dataCollectInfoText:
        "A partir de enero de 2024, el número de solicitudes de direcciones podría ser menor que antes. Esto se debe a Google cambiar la forma en que se cuentan estos datos.",
      here: "aquí",
      archiveAlert1: "Para ver la versión anterior de esta página haz clic",
      archiveAlert2:
        'La versión anterior muestra información sobre el número de búsquedas para tus ubicaciones. Sin embargo, debido a cambios en Google, todos los datos disponibles en la versión anterior se actualizarán solo hasta el <span class="text-primary">28 de febrero de 2023</span>.',
      postStatAlert2:
        'Los análisis de publicaciones estarán disponibles solo hasta el <span class="text-primary">28 de febrero de 2023</span> (debido a los cambios introducidos por Google).',
      noData:
        "Aquí puedes ver con qué frecuencia los usuarios vieron tus ubicaciones en Google Maps y Google Search y qué acciones tomaron. Esta función te ayudará a obtener información valiosa sobre el comportamiento de los usuarios.",
      title: "Acciones de los usuarios en Google Maps",
      titleTooltip:
        "Aquí puedes ver con qué frecuencia los usuarios vieron tus ubicaciones en Google Maps y Google Search y qué acciones tomaron. Esta función te ayudará a obtener información valiosa sobre el comportamiento de los usuarios.",
      subtitle: {
        search: "Búsquedas de perfiles",
        actions: "Acciones del cliente después de ver tus ubicaciones",
        displays: "Vistas de ubicaciones"
      },
      noCompare: "No compares",
      compareWithPreviousPeriod: "Periodo anterior",
      compareWithPreviousYear: "Año anterior",
      showConversionRate: "Mostrar tasa de conversión",
      chart: {
        directDiscoveryBranded: {
          title: {
            text: "Tipo de búsqueda",
            tooltip:
              "Hay múltiples maneras en que tus clientes pueden llegar a tu perfil comercial. Por ejemplo, pueden buscar tu marca directamente o escribir una categoría más general en su barra de búsqueda."
          },
          label: {
            text: {
              direct: "Búsquedas directas",
              indirect: "Búsquedas de descubrimiento",
              branded: "Búsquedas de marcas"
            },
            tooltip: {
              direct:
                "Clientes que encontraron tus anuncios por el nombre de tu marca.",
              indirect:
                "Clientes que encontraron tus listados buscando por una categoría, producto o servicio.",
              branded:
                "Clientes que encontraron tus anuncios buscando marcas asociadas con tu negocio."
            }
          }
        },
        searches: {
          title: {
            text: "Total de búsquedas",
            tooltip:
              "Número total de todos los tipos de búsquedas dentro de un período seleccionado."
          }
        },
        searchMaps: {
          title: {
            text: "Google Search vs Google Maps",
            tooltip:
              "Tu ubicación es visible en Google search y Google Maps. Aquí puedes averiguar dónde eres visto con mayor frecuencia."
          },
          label: {
            search: "Vistas en la búsqueda de Google",
            maps: "Vistas en Google Maps"
          }
        },
        maps: {
          title: {
            text: "Vistas",
            tooltip:
              "Número total de vistas de ubicaciones seleccionadas en Google Search y Google Maps."
          }
        },
        clicks: {
          title: {
            text: "Visitas al sitio web",
            tooltip:
              "Un número total de visitas a tu sitio web redirigidas desde tus ubicaciones en Google Maps."
          }
        },
        directions: {
          title: {
            text: "Solicitudes de indicaciones de viaje",
            tooltip:
              "Un número total de solicitudes de direcciones a tus ubicaciones de Google Maps."
          }
        },
        calls: {
          title: {
            text: "Llamadas telefónicas realizadas a su empresa",
            tooltip:
              "Número total de llamadas telefónicas realizadas a través de tus ubicaciones de Google Maps."
          }
        },
        clicksConversion: {
          title: {
            text: "Visitas al sitio web",
            tooltip:
              "Un número total de visitas a tu sitio web redirigidas desde tus ubicaciones en Google Maps."
          }
        },
        directionsConversion: {
          title: {
            text: "Solicitudes de direcciones de viaje",
            tooltip:
              "El número total de solicitudes de direcciones a tus ubicaciones en Google Maps."
          }
        },
        callsConversion: {
          title: {
            text: "Llamadas telefónicas realizadas a su negocio",
            tooltip:
              "El número total de llamadas telefónicas realizadas a través de tus ubicaciones de Google Maps."
          }
        },
        common: {
          totalViews: "Vistas",
          conversion: "Tasa de conversión"
        }
      }
    },
    websites: {
      noWebsitesAdded: "No se proporcionaron sitios web.",
      addWebsite: "Agregar sitio web",
      noAuditYetTryAgainLater:
        "La auditoría para este sitio web aún no está lista. Por favor, inténtelo de nuevo más tarde."
    },
    periodic: {
      title: "Posición en los resultados de búsqueda de Google Maps",
      tooltip: {
        [PERIODIC_REPORT_TYPE.TOP]:
          "Aquí puedes ver con qué frecuencia tus ubicaciones son visibles en las posiciones 1-3, 4-10 y 11-20 en los resultados de búsqueda para las palabras clave seleccionadas.",
        [PERIODIC_REPORT_TYPE.AVERAGE]:
          "Aquí puedes ver la posición promedio de tu ubicación en los resultados de búsqueda para las palabras clave seleccionadas en un período de tiempo específico."
      },
      allSelected: "(todo)",
      keywords: {
        label: "Palabras clave",
        noKeywords: "No se han elegido palabras clave",
        dialog: {
          [PERIODIC_REPORT_TYPE.TOP]: {
            title: "Elige palabras clave"
          },
          [PERIODIC_REPORT_TYPE.AVERAGE]: {
            title: "Elige palabra clave",
            infoBox:
              "Puedes elegir solo una palabra clave para el gráfico de <b>Posición media</b>"
          },
          filterInputPlaceholder: "¿Qué palabra clave estás buscando?"
        }
      },
      types: {
        [PERIODIC_REPORT_TYPE.TOP]: "Mejores posiciones",
        [PERIODIC_REPORT_TYPE.AVERAGE]: "Posición promedio"
      },
      chart: {
        tabTitle: "Gráfico",
        yAxisLabel: {
          [PERIODIC_REPORT_TYPE.TOP]: "Número de ubicaciones",
          [PERIODIC_REPORT_TYPE.AVERAGE]:
            "Posición promedio en los resultados de búsqueda de Google Maps"
        },
        noKeywordsDescription:
          "Elige palabras clave y te mostraremos\ngráficos apropiados"
      },
      table: {
        tabTitle: "Mesa",
        noKeywordsDescription:
          "Elige palabras clave y te mostraremos los datos en una tabla.",
        groupFacilities: "Agrupar ubicaciones",
        gmbAddress: "Ubicación",
        group: "Grupo",
        summary: "Resumen",
        summarySecondaryText: "de todos los lugares elegidos"
      }
    },
    comparator: {
      title: "Comparar listados de Google Maps",
      showDifference: "Mostrar diferencias",
      addDescription:
        "Aquí puedes comparar dos conjuntos de listados de Google Maps. Para ver una comparación, selecciona los listados para comparar (en los conjuntos A y B).",
      groupA: "Listados de Google Maps (conjunto A)",
      groupB: "Listados de Google Maps (conjunto B)",
      addFacilities: "Seleccionar anuncios",
      reviewsOverall: "Reseñas - todas",
      reviewsLastMonth: "Reseñas - últimos 30 días",
      averageRating: "Calificación promedio de reseñas",
      mostAccurateAverageRating:
        "Calificación promedio para las reseñas más relevantes",
      reviewsCount: "Calificaciones en total",
      reviewsRatings: "Distribución de calificaciones",
      reviewsAswersPercentage: "% de reseñas respondidas",
      postsOverall: "Publicaciones - todas",
      postsLastMonth: "Publicaciones - últimos 30 días",
      posts: "Publicaciones en total",
      postsDistribution: "Distribución de tipos de publicaciones",
      postType: {
        [POST_TYPE.STANDARD]: "Estándar",
        [POST_TYPE.EVENT]: "Evento",
        [POST_TYPE.OFFER]: "Oferta",
        [POST_TYPE.ALERT]: "Alerta"
      }
    }
  },

  companyProfile: {
    tab: {
      termsInBrowsers: "Palabras clave monitorizadas"
    },
    settings: {
      subscriptionInfo:
        "Para cambiar el plan de suscripción, ingrese el código de activación.",
      subscriptionType:
        'Estás usando el plan de suscripción "{variable}", válido hasta {variable2}.',
      subscriptionName: "Plan: {name}",
      subscriptionExpiration: "Próxima fecha de renovación: {date}",
      subscriptionExpired: "Su plan de suscripción ha expirado",
      manageSubscription: "Gestionar plan",
      pay: "Liquidar Facturas",
      expired:
        "Tu plan de suscripción ha expirado. Para renovar tu suscripción, por favor contáctanos por chat o a través del correo electrónico en support@center.ai."
    },
    noData: {
      title:
        "No tienes Perfiles de Negocio (Google Business Profile Manager) asociados con Center AI.",
      description:
        "Añade un Perfil de Negocio para beneficiarte completamente de las funcionalidades ofrecidas por Center AI. Al integrar tu cuenta de Google con Center AI, podrás editar tus listados en masa, publicar tus publicaciones en masa y monitorear la posición de tus listados en los resultados de búsqueda de Google Maps con referencia a las frases de búsqueda utilizadas."
    },
    listings: {
      title: "Cuentas de Google",
      subtitle: {
        mainSection: "Cuentas conectadas",
        asideSection: "Aplicar cambios a"
      },
      aside: {
        title: "Aplicar cambios a",
        description:
          "Por favor, selecciona los mapas que te gustaría actualizar con respecto a las ubicaciones de tu negocio. Solo actualizaremos aquellas ubicaciones donde estés registrado como propietario, es decir, aquellas que hayas importado desde tu cuenta de Google."
      },
      description: {
        mainSection:
          "Para aprovechar todas las funciones de Center AI, asegúrate de conectar tu cuenta de Google a nuestro conjunto de herramientas e importar tus ubicaciones. Todas las cuentas que ya has integrado con Center AI aparecerán aquí.",
        asideSection:
          "Por favor, seleccione los mapas que le gustaría actualizar con respecto a las ubicaciones de su negocio. Solo actualizaremos aquellas ubicaciones donde usted figura como propietario, es decir, aquellas que ha importado desde su cuenta de Google."
      },
      refreshInfo:
        "¿No puedes ver tu ubicación en la lista? Los datos se actualizan cada 10 minutos. Por favor, inténtalo de nuevo en un momento.",
      importSummary: {
        locationsImport: "Importar ubicaciones",
        lastImport: "Última importación:",
        importedLocations: "Ubicaciones importadas:",
        importedStatistics: "Importado {current_count} de {total_count}",
        importInProgress: "Importación de datos en curso.",
        lastCheckedAt: "Última vez verificado a las {time}",
        dialogMessages: {
          importing:
            "Ubicaciones seleccionadas para importar: {importing_count}",
          successfullyImported: "Ubicaciones importadas: {success_count}",
          error:
            "Algunas de las ubicaciones seleccionadas ({error_count}) no pudieron ser importadas porque faltaba alguna información para estas ubicaciones.",
          alreadyImported:
            "Algunas de las ubicaciones ({already_imported_count}) ya han sido importadas a Center AI desde otra cuenta de Google, por lo que no fue necesario importarlas nuevamente.",
          unverified: "Ubicaciones no verificadas ignoradas:"
        }
      },
      actionsDisabledDuringImport:
        "Durante la importación de datos, esta pantalla permanecerá inactiva. Sin embargo, otras funcionalidades seguirán funcionando sin obstáculos.",
      deleteBusinessAddressesListDialog: {
        title:
          "Seleccione las ubicaciones que le gustaría eliminar de Center AI"
      },
      businessAddressesListDialog: {
        noData: "No hay ubicaciones asociadas con esta cuenta",
        title: "Selecciona las ubicaciones que te gustaría importar",
        statuses: {
          is_disabled: "Deshabilitado",
          is_disconnected: "Desconectado",
          is_duplicate: "Duplicar",
          is_pending_review: "Revisión en progreso",
          is_permanently_closed: "Cerrado",
          is_published: "Publicado",
          is_suspended: "Suspendido",
          is_verified: "Verificado",
          needs_reverification: "Se necesita reverificación."
        }
      },
      confirmationDialog: {
        textImport:
          "Las ubicaciones se importaron correctamente y deberían aparecer en la lista de ubicaciones.",
        textImportPending: "Importando listados ahora.",
        textImportPendingDescription:
          "Mientras tanto, te sugerimos que te concentres en <a href='https://center.ai/blog/' target='_blank'>nuestro blog</a>. Los artículos en nuestro blog te ayudarán a comprender mejor el valor comercial que Center AI ofrece, así como sugerir algunas mejores prácticas.",
        importedStatistics: "Importado {current_count} de {total_count}",
        textDelete: "La ubicación seleccionada ha sido eliminada de Center AI.",
        textProfileDelete:
          "El perfil seleccionado y todas las ubicaciones asociadas han sido eliminadas de Center AI.",
        textAccountDelete:
          "Tu cuenta y todos los perfiles asociados han sido eliminados de Center AI.",
        importErrorTitle: "Se produjo un error al agregar una nueva cuenta.",
        deleteErrorTitle:
          "Se produjo un error al eliminar la cuenta de Center AI.",
        deleteProfileErrorTitle:
          "Se produjo un error al eliminar el perfil de Center AI.",
        deleteAccountErrorTitle:
          "Se produjo un error al eliminar la cuenta de Google de Center AI",
        deleteAccountConfirm:
          "¿Estás seguro de que te gustaría eliminar la cuenta de Google de Center AI?",
        deleteProfileConfirm:
          "¿Está seguro de que desea eliminar el perfil de Center AI?",
        deleteFacilityConfirm:
          "¿Está seguro de que desea eliminar la ubicación de Center AI?",
        importErrorText:
          "Uy, algo salió mal... No se pudieron importar tus ubicaciones. Por favor, inténtalo de nuevo.",
        deleteErrorText:
          "Vaya, algo salió mal... No se pudieron eliminar las ubicaciones seleccionadas. Por favor, inténtelo de nuevo.",
        deleteProfileErrorText:
          "Ups, algo salió mal... el perfil no pudo ser eliminado. Por favor, inténtalo de nuevo.",
        deleteAccountErrorText:
          "Ups, algo salió mal... No se pudo eliminar la cuenta de Google. Por favor, inténtalo de nuevo.",
        tooManyRequestsErrorText:
          "Tu plan de suscripción no permite tantas ubicaciones. Para aumentar la cuota de ubicaciones, por favor envíanos un correo electrónico a support@center.ai o utiliza el chat en la esquina inferior derecha de la pantalla.",
        preAddAccount: {
          title: "Permisos para Center AI",
          description:
            "Center AI requiere permisos de acceso a las ubicaciones de tu negocio en Google Maps. Esto es necesario para ayudarte en la gestión de ubicaciones.",
          descriptionSecondary:
            "Para otorgar estos permisos, marque una casilla cuando se le pida permiso, como se muestra a continuación:",
          imgAlt: "Cómo marcar la casilla correcta."
        },
        postAddAccount: {
          error: {
            title: "Permisos para Center AI",
            description:
              "La adición de la cuenta de Google falló porque no has otorgado los permisos necesarios.",
            descriptionSecondary:
              "Center AI requiere permisos para tus ubicaciones comerciales en Google Maps. Esto es necesario para ayudarte en la gestión de ubicaciones."
          }
        }
      },
      noProfilesAdded: "Aún no se han agregado perfiles."
    },
    monitoredKeywords: {
      title: "Palabras clave monitoreadas",
      subtitle: "¿Qué buscan tus clientes?",
      subtitleTooltip:
        "Escribe palabras clave para las que deseas monitorear tu posición.",

      keywordsScope: "Alcance de palabras clave",
      scope: {
        [KEYWORDS_SCOPE.COMPANY]: "Todas las ubicaciones",
        [KEYWORDS_SCOPE.GROUP]: "Grupo",
        [KEYWORDS_SCOPE.FACILITY]: "Ubicación elegida"
      },
      keywordsSection: {
        title: "Palabras clave monitorizadas",
        keywordInputPlaceholder: "Agregar palabra clave",
        infoBoxContent:
          "Para agregar una palabra clave, escríbela arriba y presiona Enter en tu teclado o haz clic en el botón Agregar.",
        noKeywords: "Actualmente no estás monitoreando ninguna palabra clave.",
        noKeywordsAlt: "Sin palabras clave"
      },
      deleteDialogLabel: "¿Te gustaría eliminar la palabra clave seleccionada?",
      chosenKeywordDeleted: "La palabra clave elegida ha sido eliminada"
    }
  },

  facilityDetails: {
    title: "Detalles de ubicación",
    backToFacilitiesList: "Volver a la lista de ubicaciones",
    showIn: "Mostrar en",
    mapButton: "Google Maps",
    bingMapButton: "Bing Maps",
    startDate: "Fecha de apertura",
    openingHours: "Horario de atención",
    openingHoursInfoText:
      "Se establecerá el siguiente horario de apertura para toda la semana. Por ejemplo, si estableces tu horario de apertura de 9 a.m. a 5 p.m. solo para los lunes, mientras que todos los demás días se establecerán como cerrados, entonces, como resultado de los cambios, todos los horarios de apertura tanto los lunes como los días restantes serán modificados (como se indicó en el formulario anterior).",
    customOpeningHours: "Horario especial de apertura",
    customOpeningHoursInfoText:
      "El horario de apertura se establecerá solo para los días seleccionados anteriormente. No se modificará ningún otro día.",
    allDayOpeningHours: "Abierto 24h",
    statusOnMaps: "Estado en los mapas",
    typeOfMap: "Mapa",
    status: "Estado",
    details: "Detalles",
    lastUpdateDate: "Última actualización",
    reviewFormLink: "Enlace al formulario de envío de reseñas en Google Maps",
    technicalDetailsDialog: {
      title: "Detalles técnicos",
      locationName: "gmb_location_name"
    },
    statuses: {
      pending: "Esperando actualización",
      inProgress: "Actualización en progreso",
      ok: "Actualizado",
      failed: "Actualización fallida",
      externalChange: "Cambios externos en la información comercial",
      noData: "Sin datos sobre el estado",
      lastUpdateNoData: "Fecha de la última actualización desconocida"
    },
    statusDescription:
      "Puedes ver el estado de tus actualizaciones a continuación. Center AI actualiza tus ubicaciones de Google Maps en unos pocos minutos. Sin embargo, puede tardar más debido a la verificación de datos de Google.",
    forms: {
      streetAndHomeNumber: "Número de casa/piso.",
      websiteAddress: "Dirección del sitio web",
      phoneOne: "Número de teléfono 1",
      phoneTwo: "Número de teléfono 2"
    },
    addWorkingHours: "Agregar horario de apertura",
    addAnotherDay: "Agrega otro día",
    validation: {
      date: "Se requiere el año y el mes"
    },
    footer: {
      openingHours:
        "Una vez guardados, los cambios pasarán por verificación, lo cual puede tardar hasta 3 días. Normalmente toma unos pocos minutos."
    },
    noChangesInForm:
      "No hay cambios en el formulario. Por favor, selecciona el campo que te gustaría actualizar.",
    facilityDescription: "Descripción de la ubicación del negocio",
    urlAttributes: {
      title: "atributos de URL",
      facilityAttributes: "Atributos de URL de ubicación",
      facilitiesAttributes: "Atributos de URL de ubicación",
      noAttributesSelected: "No se seleccionaron atributos de URL.",
      editMessage:
        "Agrega o elimina atributos de URL (enlaces), por ejemplo, un enlace al menú de tu restaurante, para comunicar más información sobre tus ubicaciones.",
      addAttributes: "Agregar atributos de URL",
      addAttributesInfo:
        "Agrega atributos de URL para comunicar más información sobre tus ubicaciones y facilitar la conexión con valiosas fuentes externas.",
      addingAttributes: "Agregando atributos de URL",
      addAttributesQuestion:
        "¿Te gustaría agregar atributos adicionales a la URL?",
      addAttributesDescription:
        "Proporcione atributos de URL para agregar a las ubicaciones seleccionadas. Los nuevos atributos de URL se agregarán junto con los atributos de URL ya existentes sin cambiarlos.",
      deleteAttributes: "Eliminar atributos de URL",
      deletingAttributes: "Eliminando atributos de URL",
      deleteAttributesQuestion:
        "¿Te gustaría eliminar los atributos de URL seleccionados?",
      deleteAttributesDescription:
        "Elija los atributos de URL que desea eliminar en las ubicaciones seleccionadas. Solo se eliminarán los atributos de URL seleccionados. Otros atributos de URL permanecerán sin cambios.",
      changeType: "¿Tienes algo más en mente? Seleccionar:",
      changeTypeConfirm:
        'Si decides cambiar el modo de edición de atributos, todos los datos bajo los "atributos de URL de ubicación" en tu formulario serán borrados. Los datos serán borrados solo en el formulario, los atributos de URL de ubicación individual no cambiarán. ¿Te gustaría continuar?',
      dialog: {
        title: "Atributos de URL",
        description:
          "A continuación, puedes agregar, editar y eliminar atributos de URL.",
        noAttributes: "Sin atributos de URL",
        noAttributesAvailable:
          "Esta ubicación no puede tener atributos URL adicionales. Los atributos URL adicionales solo están permitidos para ciertas categorías de negocios (por ejemplo, restaurantes).",
        noAttributesToDeleteMassEdit: "No hay atributos de URL que eliminar.",
        noAttributesAvailableMassEdit:
          "La adición de atributos de URL es imposible, ya que las ubicaciones elegidas no tienen atributos de URL comunes.",
        notEditable:
          "Los URL en esta sección no se pueden actualizar (Google no permite hacerlo).",
        validationError:
          "Algunas de las URL en un formulario son incorrectas. Por favor, corrígelas y guarda de nuevo.",
        addAttributeBtn: "Agregar atributo URL",
        applyBtn: "Guardar"
      }
    },
    services: {
      validation: {
        descriptionLength:
          "La descripción del servicio no puede exceder los {0} caracteres",
        serviceExists: "El servicio ya existe",
        required: "Este campo es obligatorio"
      },
      addDescription: "Añadir descripción",
      customServices: "Servicios personalizados",
      standard: "Estándar",
      custom: "Personalizado",
      title: "Servicios",
      addNext: "Agregar siguiente servicio",
      selectServiceCategory: "Seleccionar categoría de servicio",
      noServicesSelected: "No has seleccionado servicios.",
      addServicesInfo: "Agrega los servicios que ofreces en tu negocio.",
      addAnotherCustomService: "Agregar otro servicio personalizado",
      addCustomService: "Agregar servicio personalizado",
      customService: "Servicio personalizado",
      missingServiceQuestion: "¿No ves el servicio que ofreces?",
      serviceDescription: "Descripción del servicio",
      servicePrice: "Precio del servicio ({0})",
      price: "Precio",
      noPrice: "Sin precio",
      priceFrom: "Precio desde",
      priceTo: "Precio a",
      fixedPrice: "Precio fijo",
      deleteService: "Eliminar servicio",
      deleteServiceDialogText:
        "¿Estás seguro de que quieres eliminar este servicio?",
      closeServiceDialogText:
        "¿Estás seguro de que deseas cerrar la ventana? Los cambios no guardados se perderán.",
      addServices: "Agregar servicios",
      editServices: "Servicios de edición",
      deleteServices: "Eliminar servicios",
      findService: "Buscar servicios",
      addingServices: "Añadir servicios",
      addServicesQuestion: "¿Deseas agregar servicios adicionales?",
      addServicesDescription:
        "Seleccione los nuevos servicios que desea agregar a los listados seleccionados. Los servicios se añadirán a los existentes, preservando el estado de otros servicios.",
      deletingServices: "Eliminando servicios",
      deleteServicesQuestion: "¿Desea eliminar los servicios seleccionados?",
      deleteServicesDescription:
        "Seleccione los servicios que desea eliminar de los listados seleccionados. Solo se eliminarán los servicios seleccionados. Los demás servicios permanecerán sin cambios.",
      overwriteServices: "Configurar servicios",
      overwritingServices: "Configuración de servicios",
      overwriteServicesQuestion:
        "¿Quieres configurar (sobrescribir) servicios?",
      overwriteServicesDescription:
        "Seleccione los servicios que desea configurar en los listados seleccionados. Esta operación eliminará todos los servicios actuales y los reemplazará con los que haya seleccionado.",
      clickToRestore: "Haz clic para restaurar",
      duplicateError: "El servicio {0} ya existe",
      changeType: "¿Tienes algo más en mente? Selecciona:",
      changeTypeConfirm:
        'Si decides cambiar el modo de edición de servicios, todos los datos bajo "Servicios" en tu formulario se borrarán. Los datos se borrarán solo en el formulario, los servicios de ubicaciones individuales no cambiarán. ¿Te gustaría continuar?'
    },
    attributes: {
      title: "Atributos",
      facilityAttributes: "Atributos de ubicación",
      facilitiesAttributes: "Atributos de ubicación",
      findAttributes: "Encontrar atributos",
      facilityDescription: "Descripción de la ubicación comercial",
      noAttributesSelected: "No se seleccionaron atributos",
      editMessage:
        "Agrega, elimina o establece atributos para comunicar más información sobre tus ubicaciones y resaltar sus principales características. Los atributos comprenden información como los métodos de pago, accesibilidad o Wi-Fi gratuito, etc.",
      addAttributes: "Agregar atributos",
      addAttributesInfo:
        "Agrega atributos para comunicar más información sobre tus ubicaciones y resaltar sus principales características. Los atributos comprenden información como métodos de pago, accesibilidad o Wi-Fi gratis, etc.",
      addingAttributes: "Añadiendo atributos",
      addAttributesQuestion: "¿Te gustaría agregar atributos adicionales?",
      addAttributesDescription:
        "Elija los atributos para agregar a las ubicaciones seleccionadas. Los nuevos atributos se añadirán junto a los ya existentes sin cambiarlos.",
      deleteAttributes: "Eliminar atributos",
      deletingAttributes: "Eliminando atributos",
      deleteAttributesQuestion:
        "¿Te gustaría eliminar los atributos seleccionados?",
      deleteAttributesDescription:
        "Elija los atributos que le gustaría eliminar en las ubicaciones seleccionadas. Solo se eliminarán los atributos seleccionados. Otros atributos permanecerán sin cambios.",
      overwriteAttributes: "Establecer atributos",
      overwritingAttributes: "Establecer atributos",
      overwriteAttributesQuestion:
        "¿Te gustaría establecer o sobrescribir los atributos existentes?",
      overwriteAttributesDescription:
        "Por favor, seleccione los atributos que le gustaría establecer en las ubicaciones seleccionadas. Esto eliminará todos los atributos actuales en las ubicaciones seleccionadas y establecerá nuevos atributos en su lugar.",
      changeType: "¿Tienes algo más en mente? Selecciona:",
      changeTypeConfirm:
        'Si decides cambiar el modo de edición de atributos, todos los datos bajo "atributos de ubicación" en tu formulario serán eliminados. Los datos se eliminarán solo en el formulario, los atributos de la ubicación individual no cambiarán. ¿Te gustaría continuar?'
    },
    categories: {
      primary: {
        title: "Elija la categoría principal de negocio",
        queryPlaceholder: "Buscar por categoría",
        applyBtnText: "Conjunto"
      },
      additional: {
        title: "Elija una categoría de negocio adicional",
        queryPlaceholder: "Buscar por categoría",
        applyBtnText: "Agregar",
        bulkEditApplyBtnText: "Seleccionar",
        bulkEditTooltip:
          "Las categorías comerciales adicionales seleccionadas anteriormente anularán (eliminarán) las categorías comerciales adicionales que actualmente están configuradas para las ubicaciones seleccionadas."
      },
      deleteCategoryDialogTitle: "¿Desea eliminar la categoría seleccionada?",
      mayNeedVerification:
        "Después de agregar o editar una categoría, Google puede solicitar la verificación de la ubicación nuevamente."
    },
    labels: {
      title: "Etiquetas",
      deleteLabelDialogTitle: "¿Te gustaría eliminar la etiqueta seleccionada?",
      facilityLabels: "Etiquetas de ubicación",
      facilitiesLabels: "Etiquetas de ubicación",
      findLabels: "Encontrar etiquetas",
      facilityDescription: "Descripción de la ubicación del negocio",
      noLabels: "Sin etiquetas",
      noLabelsSelected: "No se seleccionaron etiquetas",
      editMessage:
        "Añadir, eliminar o establecer etiquetas. Las etiquetas no son visibles públicamente en Google Maps.",
      addLabels: "Agregar etiquetas",
      addLabelsInfo:
        "Agrega etiquetas para comunicar más información sobre tus ubicaciones y resalta sus etiquetas principales.",
      addingLabels: "Agregando etiquetas",
      addLabelsQuestion: "¿Te gustaría añadir etiquetas adicionales?",
      addLabelsDescription:
        "Elija etiquetas para añadir a las ubicaciones seleccionadas. Las nuevas etiquetas se añadirán junto a las etiquetas ya existentes sin cambiarlas.",
      deleteLabels: "Eliminar etiquetas",
      deletingLabels: "Eliminar etiquetas",
      deleteLabelsQuestion:
        "¿Te gustaría eliminar las etiquetas seleccionadas?",
      deleteLabelsDescription:
        "Elige las etiquetas que te gustaría eliminar en las ubicaciones seleccionadas. Solo se eliminarán las etiquetas seleccionadas. Las demás etiquetas permanecerán sin cambios.",
      overwriteLabels: "Establecer etiquetas",
      overwritingLabels: "Establecer etiquetas",
      overwriteLabelsQuestion:
        "¿Te gustaría configurar o sobrescribir las etiquetas existentes?",
      overwriteLabelsDescription:
        "Por favor, selecciona las etiquetas que te gustaría establecer en las ubicaciones seleccionadas. Esto eliminará todas las etiquetas actuales en las ubicaciones seleccionadas y establecerá nuevas etiquetas en su lugar.",
      changeType: "¿Tienes algo más en mente? Seleccionar:",
      changeTypeConfirm:
        'Si decides cambiar el modo de edición de etiquetas, todos los datos bajo "Etiquetas de ubicación" en tu formulario se borrarán. Los datos se borrarán solo en el formulario, las etiquetas de cada ubicación individual no cambiarán. ¿Te gustaría continuar?',
      dialog: {
        title: "Etiquetas",
        description:
          "Aquí puedes añadir, editar y eliminar etiquetas para la ubicación seleccionada.",
        noLabels: "Sin etiquetas.",
        addLabelBtn: "Agregar etiqueta",
        applyBtn: "Aplicar"
      }
    },
    moreHours: {
      title: "Más horas",
      facilitiesMoreHours: "Ubicación más horas",
      noMoreHoursSelected: "No se seleccionaron más horas",
      editMessage:
        "Establecer o eliminar más horas, por ejemplo, relacionadas con el horario de entrega.",
      setMoreHours: "Establecer más horas",
      setMoreHoursInfo:
        "Establezca más horas para comunicar más información sobre el horario de apertura de los servicios específicos en sus ubicaciones.",
      settingMoreHours: "Estableciendo más horas",
      setMoreHoursQuestion: "¿Te gustaría establecer más horas?",
      setMoreHoursDescription:
        "Seleccione más horas que desee configurar en las ubicaciones seleccionadas. Esto eliminará todas las horas adicionales actuales en las ubicaciones seleccionadas y establecerá nuevas etiquetas en su lugar.",
      deleteMoreHours: "Elimina más horas",
      deletingMoreHours: "Eliminando más horas",
      deleteMoreHoursQuestion: "¿Te gustaría eliminar más horas seleccionadas?",
      deleteMoreHoursDescription:
        "Elige más horas que te gustaría eliminar en las ubicaciones seleccionadas. Solo se eliminarán las horas adicionales seleccionadas. Otras horas permanecerán sin cambios.",
      changeType: "¿Tienes algo más en mente? Selecciona:",
      changeTypeConfirm:
        'Si decides cambiar más horas en el modo de edición, todos los datos en "Ubicación más horas" en tu formulario se borrarán. Los datos se borrarán solo en el formulario, las más horas de la ubicación individual no cambiarán. ¿Te gustaría continuar?',
      categoriesDialog: {
        description:
          "Puede añadir horas adicionales para ciertos servicios u ofertas en la ubicación seleccionada.",
        descriptionMassEdit:
          "Puedes añadir horas adicionales para ciertos servicios u ofertas en ubicaciones seleccionadas.",
        chooseCategory: "Elige categoría:",
        chooseCategoriesToDelete: "Elige las categorías para eliminar:",
        noCategories: "No hay categorías disponibles."
      }
    },
    openStatusDialog: {
      title: "Apertura y cierre de ubicación"
    },
    addingFacilityToGoogleMapsInProgressInfoText:
      "No puedes editar esta ubicación porque actualmente se está añadiendo a Google Maps."
  },

  facilityCreate: {
    title: "Crear ubicación",
    cancelCreating: "Cancelar creación",
    baseForm: {
      heading: "Datos de ubicación",
      headingSecondary: "Proporciona el nombre y la dirección del lugar.",
      required: "Este campo es obligatorio"
    },
    primaryCategoryRequired: "La categoría principal es obligatoria.",
    accountSelect: {
      heading: "Cuenta de Google",
      headingSecondary:
        "Elige la cuenta de Google y el perfil a los que deseas añadir una nueva ubicación:",
      noAccounts:
        "No hay cuentas de Google disponibles, no se puede crear ubicación."
    },
    createDisabled:
      "La creación de nuevos listados en Google Maps desde el panel de Center AI está desactivada en tu cuenta.\nPara activarla, por favor contacta con el soporte (support@center.ai).",
    dialog: {
      facilityCreated: {
        title:
          "La ubicación se ha añadido exitosamente a Google Business Profile Manager.",
        subtitle: "(Cuenta GMB: {account}, perfil: {profile})",
        importedToCenter: "y ha sido importado a Center AI.",
        verificationStarted:
          "El proceso de verificación de ubicación ha comenzado y debería finalizar pronto.",
        goToFacilitiesList: "Ir a la lista de ubicaciones",
        createNew: "Crear la siguiente ubicación"
      },
      facilityImported: {
        description:
          "La ubicación se está importando a Center AI y estará disponible en la lista de ubicaciones en unos minutos.",
        goToBtn: "Ir a la lista de ubicaciones"
      },
      createDuplicate: {
        title: "Esa ubicación ya existe en Google Maps",
        description: {
          main:
            "Si añades esta ubicación, corres el riesgo de crear un duplicado. Los duplicados pueden confundir a tus clientes y es posible que Google no muestre ubicaciones duplicadas en Google Maps.",
          more: ""
        },
        sureToContinue: "¿Quieres continuar?",
        confirmBtn: "Sí, crea esta ubicación en Google Maps."
      },
      inCenter: {
        title: "La ubicación ya está en tu cuenta de Google",
        paragraphFirst:
          "La ubicación con el nombre y dirección proporcionados ya está añadida a tu cuenta de Google (cuenta GMB: {account}, perfil: {profile}) y está importada a Center AI.",
        paragraphSecond:
          "No es necesario añadirlo de nuevo. Si deseas actualizar sus datos, ve a la vista de edición de ubicación.",
        goToEditView: "Editar datos de ubicación"
      },
      inGoogle: {
        title: "Administrador de Perfiles de Negocio de Google ubicación",
        createNewFacility: "Crear nueva ubicación en Google Maps",
        choiceHeader:
          "Selecciona la ubicación para agregar a tu cuenta de Google.",
        descriptionTop: {
          onlyExistsInAccount:
            "La ubicación con este nombre y dirección ya ha sido añadida a tu cuenta de Google, pero aún no se ha importado a Center AI. Por lo tanto, solo necesitas importarla a Center AI.",
          mixWithAndWithoutOwner:
            "La ubicación con este nombre y dirección ya existe en Google Maps pero aún no se ha agregado a tu cuenta de Google. Las ubicaciones que hemos encontrado se presentan en la lista a continuación.",
          mixAll:
            "La ubicación con este nombre y dirección ya está añadida a tu cuenta de Google, pero aún no se ha importado a Center AI. Por eso, solo necesitas importarla a Center AI. También hemos notado que una ubicación con este nombre y dirección ya existe en Google Maps, pero aún no se ha añadido a tu cuenta de Google."
        },
        [FACILITY_CREATE_ACTION.EXISTS_IN_ACCOUNT]: {
          text: "La ubicación existe en tu cuenta de GMB.",
          tooltip:
            "La ubicación ya está añadida a tu cuenta de Google, pero aún no se ha importado a Center AI. Solo necesitas importarla a Center AI. No es necesario crear una nueva ubicación.",
          descriptionBottom:
            "La ubicación seleccionada ya está añadida a tu cuenta de GMB con el nombre {account} en el perfil {profile}. Será importada a Center AI utilizando esta cuenta y perfil de GMB.",
          goTo: "Ver en Google Business Profile Manager",
          applyBtn: "Importación"
        },
        [FACILITY_CREATE_ACTION.WITH_OWNER]: {
          text: "La ubicación existe en Google Maps y tiene otro propietario.",
          tooltip:
            "Esta ubicación tiene otro propietario que fue agregado y verificado anteriormente en Google Maps por otra persona. Esta persona es el propietario actual de esta ubicación en Google Maps. Para obtener acceso a esta ubicación, necesitarás permiso de esta persona.",
          goTo: "Ver en Google Maps",
          applyBtn: "Solicitar acceso a esta ubicación",
          tooltipBottom:
            "Después de presionar este botón, serás redirigido a un formulario que te permitirá contactar con el propietario actual de esta ubicación. El formulario contendrá una parte de la dirección de correo electrónico de esta persona. Si reconoces esta dirección de correo electrónico, es una buena idea contactar a esta persona directamente y pedir permiso. Si no la reconoces, entonces debes completar y enviar este formulario. Después de eso, Google informará al propietario actual sobre tu solicitud. El propietario tendrá unos días para aceptar o rechazar tu solicitud. Si es rechazada, aún puedes hacer una apelación en tu panel de Google (Business Profile Manager). La falta de respuesta por parte del propietario actual será tratada por Google como aceptación de tu solicitud."
        },
        [FACILITY_CREATE_ACTION.WITHOUT_OWNER]: {
          text: "La ubicación existe en Google Maps y no tiene propietario.",
          tooltip:
            "Esta ubicación se agregó anteriormente a Google Maps, pero aún no está verificada. Esto significa que se puede agregar fácilmente a tu cuenta.",
          goTo: "Ver en Google Maps",
          applyBtn: "Agregar a la cuenta de Google"
        }
      }
    }
  },

  facilitiesEdit: {
    editSuccess: "Edición exitosa",
    bulkEditMessage:
      "Se está realizando una edición masiva de los datos de ubicaciones. Hasta que se termine, no puedes realizar nuevas ediciones masivas de ubicaciones.",

    title: "Edición masiva de ubicaciones",
    checkFieldsDescription:
      "Seleccione los campos que le gustaría actualizar e ingrese sus cambios. Los cambios se implementarán en todas las ubicaciones seleccionadas."
  },

  facilitiesAddNew: {
    addExistingFacilities: "Agregar ubicaciones existentes",
    importFromGoogleMyBusiness:
      "Importar ubicaciones desde Google Business Profile Manager",
    importFromGoogleMyBusinessDescription:
      "Inicia sesión en tu cuenta de Google y selecciona las ubicaciones que deseas agregar. Los datos se importarán automáticamente.",
    analysisPositionAtGoogleMaps: "Analizar posiciones en Google Maps Search",
    comparingWithCommercialFacilities:
      "Comparar con las ubicaciones de los competidores",
    updateDataOnGoogleMaps: "Actualizar datos en Google Maps",
    updateDataOnOtherMaps: "Actualizar datos en otros mapas",
    accessToStatistics:
      "Accede a los análisis sobre búsquedas de usuarios y comportamiento de usuarios para ubicaciones en Google Maps.",
    searchOnGoogleMaps: "Buscar en Google Maps",
    searchOnGoogleMapsDescription:
      "Busca la ubicación en Google Maps utilizando su dirección o nombre. Cualquier dato que esté disponible públicamente se descargará automáticamente.",
    addFacilitySearchingOnTheMap:
      "Agregar ubicación mediante búsqueda en Google Maps",
    addFacilitySearchingOnTheMapDescription:
      "Busca la ubicación en Google Maps usando su dirección o ingresa su nombre a continuación. Cualquier dato que esté disponible públicamente se descargará automáticamente.",
    noAccess: "No estás autorizado para añadir nuevas ubicaciones."
  },

  wizard: {
    addNameAndchooseFromList: "Ingresa el nombre o elige de la lista",
    streetAndHomeNumber: "Dirección postal",
    fillTaxNumber:
      "Introduzca su NIP (solo para empresas registradas en Polonia)",
    taxNumberFieldDescription:
      "Si su empresa está registrada en Polonia, puede proporcionar su número de identificación fiscal de la empresa (NIP) a continuación para obtener automáticamente información sobre su empresa.",

    businessAddresses: {
      method: {
        title: "Agrega tus ubicaciones desde Google Maps",
        description:
          "Agrega tu cuenta de Google para añadir automáticamente todas tus ubicaciones de Google Maps.",
        addManually: "Agregar ubicación manualmente"
      }
    },

    companyInWeb: {
      name: "Tu negocio en línea",
      header: "¿Cómo te encuentran tus clientes en línea?",
      termsTitle: "¿Qué buscan tus clientes?",
      termsDescription:
        "Palabras clave que los usuarios ingresan en la búsqueda de Google Maps para buscar tu negocio o empresas similares.",
      localityTitle: "¿Dónde están tus clientes?",
      localityDescription:
        "¿En qué ciudades y ubicaciones residen sus clientes potenciales?",
      settingsTitle: "¿Qué te gustaría que tus clientes encontraran?",
      settingsDescription:
        "Elige una ubicación o sitio web de la lista para establecer los parámetros.",
      suggestedAll: "Añadir a todas las ubicaciones y sitios web",
      suggestedWebsites: "Añadir a todos los sitios web.",
      facilitiesAll:
        "Agregar palabra clave de búsqueda a todas las ubicaciones",
      facilitiesSelected:
        "Agregar palabra clave de búsqueda solo a ubicaciones seleccionadas",
      removeLabel:
        "¿Deseas eliminar la palabra clave de todas las ubicaciones o solo de una ubicación seleccionada?",
      facilitiesRemoveAll: "Eliminar de todas las ubicaciones",
      facilitiesRemoveSelected: "Eliminar solo de los seleccionados",
      businessAddress: "Ubicación del negocio",
      noAddressesSelected:
        "No se especificó ninguna ubicación. Para continuar, por favor añade al menos una ubicación de negocio.",
      inLocationVicinity: "en las cercanías de la ubicación"
    },

    validation: {
      companyNotFound:
        "el siguiente número NIP no devuelve detalles de ninguna empresa. Por favor, asegúrate de haber ingresado el número NIP correcto."
    }
  },

  average: {
    veryWeak: "Muy pobre",
    weak: "Pobre",
    medium: "Medio",
    good: "Bien",
    veryGood: "Excelente"
  },

  error: {
    badRequest:
      "Solicitud no válida. Por favor, contacta a nuestro equipo de soporte.",
    unauthorized: "Autorización requerida. Por favor, inicia sesión.",
    notFound:
      "No se encontraron activos. Por favor, contacte a nuestro equipo de soporte.",
    server:
      "Error del servidor. Por favor, contacta con nuestro equipo de soporte.",
    other: "Error. Por favor, contacta a nuestro equipo de soporte.",
    parsing: "Se produjo un error al analizar los datos",
    requiredField: "Requerido",
    noAccounts: "No se añadieron cuentas"
  },

  businessAddresses: {
    list: {
      facilityIs: "Instalación es",
      isDuplicate: "un duplicado",
      isDisconnected: "desconectado",
      editTooltip:
        "Aquí puedes editar rápidamente varias ubicaciones en masa seleccionando más de una.",
      tabTitle: "Lista de ubicaciones",
      searchPlaceholder: "Nombre, dirección, código de tienda",
      delete: "Eliminar de Center AI",
      addingToGoogleMaps: "Añadiendo a Google Maps",
      totalFacilitiesCount: "Todas las ubicaciones: {0}",
      ignoreUnverifiedFacilities: "Ignorar ubicaciones no verificadas"
    },
    groups: {
      tabTitle: "Grupos de ubicaciones",
      noGroups: {
        description:
          "¡Crea grupos y agrupa tus ubicaciones para facilitar la gestión de la información!",
        button: "Agregar nuevo grupo"
      },
      labelGroups: {
        addBtn: "Agregar nuevo grupo conectado a las etiquetas de GMB",
        labelGroupListItemTooltip: "Conectado a las etiquetas GMB",
        labelGroupTooltip:
          "Este grupo es gestionado automáticamente por Center AI. El sistema agregará o eliminará ubicaciones a este grupo automáticamente en función de los cambios en las etiquetas GMB de las ubicaciones. Las ubicaciones de este grupo no se pueden agregar ni eliminar manualmente.",
        addGroupDialog: {
          title: "Seleccionar etiquetas",
          description:
            "Selecciona las etiquetas de GMB que se utilizarán para crear este grupo de ubicaciones. Todas las ubicaciones con todas las etiquetas seleccionadas se agregarán a este grupo. Este grupo será gestionado automáticamente por Center AI, lo que significa que el sistema agregará o eliminará automáticamente ubicaciones de este grupo según los cambios en las etiquetas de las ubicaciones."
        }
      },
      groupNotSelected: "No se seleccionó ningún grupo",

      addNewGroup: {
        title: "Agregar grupo",
        chosenCompany: "Compañía seleccionada: {0}",
        newGroupName: "Nombre del grupo",
        successfullyAdded: 'El grupo "{0}" fue creado con éxito'
      },

      editGroup: {
        title: "Editar el nombre del grupo",
        chosenCompany: "Seleccionada empresa: {0}",
        newGroupName: "Nombre del grupo",
        successfullyUpdated: "El grupo fue editado exitosamente."
      },

      emptyGroup:
        "Agrupar ubicaciones para facilitar la gestión de la información.",
      createdGroups: "Tus grupos:",
      groupSuccessfullyDeleted: 'El grupo "{0}" fue eliminado con éxito',

      facilities: {
        facilitiesInGroup: "Ubicaciones en este grupo",
        addFacilitiesButton: "Agregar ubicaciones",
        emptyGroup:
          "Agrupar ubicaciones para facilitar la gestión de la información",
        filterInputPlaceholder: "¿Qué ubicación estás buscando?",
        noFacilitiesMatchingQuery:
          "Ninguna ubicación coincide con la consulta de búsqueda",
        addFacilitiesToGroup: "Agregar ubicación al grupo",
        selectedGroup: "Grupo seleccionado: {0}",
        facilitiesAdded: 'Se añadieron ubicaciones al grupo "{0}"',
        facilityDeleted: 'La ubicación "{0}" fue eliminada del grupo "{1}"',
        facilitiesDeleted: 'Se eliminaron ubicaciones del grupo "{0}"'
      }
    },
    quality: {
      viewTitle: "Calidad de las ubicaciones de Google Maps",
      actionButtons: {
        information: {
          add: {
            text:
              "Proporcione toda la información necesaria sobre su ubicación a sus clientes.",
            label: "Agregar información"
          },
          edit: {
            text:
              "Asegúrate de que la información sobre tu ubicación esté actualizada.",
            label: "Editar información"
          }
        },
        reviews: {
          text: "Cuida de tus clientes respondiendo a sus reseñas.",
          label: "Responder a las reseñas"
        },
        photos: {
          text: "Sube fotos para mostrar tu mejor lado.",
          label: "Subir fotos"
        },
        posts: {
          text:
            "Agrega publicaciones para informar a tus clientes sobre ofertas y novedades.",
          label: "Agregar publicaciones"
        }
      }
    }
  },

  externalChanges: {
    title: "Cambios externos",
    hasExternalChanges:
      "Hay cambios externos que deben ser aceptados o rechazados.",
    noChanges:
      "Center AI monitorea cualquier cambio en tus listados sugerido por usuarios distintos a ti cuando la función Proteger contra Cambios está activada. Actualmente, no tienes sugerencias de cambios o todas las sugerencias han sido rechazadas/aceptadas.",
    noChangesHistory: "El historial de cambios externos está vacío.",
    noChangesAlt: "Sin cambios externos.",
    automaticChange: "Protección de Center AI",
    list: {
      title: "Lista de cambios externos",
      searchPlaceholder: "Nombre, dirección, código de ubicación",
      overLimitTooltip:
        "Se pueden realizar acciones en masa para un máximo de {count} ubicaciones."
    },
    protect: {
      title: "Protección contra cambios externos",
      description:
        "Aquí puedes decidir si deseas aceptar o rechazar los cambios externos de los usuarios de Google en tus ubicaciones. Cuando se detecten cambios, Center AI realizará automáticamente algunas de estas acciones por ti. Sin embargo, para rechazar algunos de los cambios, tendrás que confirmarlo manualmente.",
      type: {
        external: "Cambios externos",
        gmb: "Cambios en el Administrador de Perfiles de Negocio de Google"
      },
      alwaysAccept: "Aceptar",
      alwaysReject: "Rechazar",
      allFields: "Todos los campos",
      infoDialog: {
        title: "La configuración ha sido guardada.",
        textContentFirst:
          "Tus listados serán monitoreados según la configuración para encontrar cambios que ocurrieron fuera de Center AI. Se te notificará cuando se detecten cambios que desees rechazar. Necesitarás confirmar su rechazo. Los cambios que desees aceptar serán manejados por Center AI (no se requerirá tu acción).",
        showChangesBtn: "Ver cambios detectados anteriormente"
      }
    },
    history: {
      title: "Historial de cambios externos",
      searchPlaceholder: "Nombre, dirección, código de ubicación",
      changeHeaderTooltip:
        "Cambio en los datos de ubicación que fue realizado, aceptado o rechazado.",
      showAllChanges: "Mostrar todos los cambios ({count})"
    },
    date: "Fecha",
    origin: "Fuente",
    type: "Cambiar tipo",
    user: "Usuario",
    field: "Campo cambiado",
    change: "Cambiar",
    allChanges: "Todos los cambios: {count}",
    action: "Acción",
    actionPerformed: "Acción realizada",
    changeDetected: "Cambio detectado",
    additionTooltip: "Agregó nueva información.",
    removalTooltip: "Información existente eliminada.",
    changeTooltip: "Cambié la información existente.",
    selectedFacilities: "Ubicaciones seleccionadas: {0}",
    groupChangeDialog: {
      [EXTERNAL_CHANGES_STATUS.ACCEPTED]: {
        title: "Aceptar cambios externos",
        text:
          "Seleccione los cambios a aceptar en las ubicaciones seleccionadas.",
        button: "Aceptar",
        [EXTERNAL_CHANGES_SOURCE.GMB]:
          "Aceptas cambios solo de este origen: Google Business Profile Manager",
        [EXTERNAL_CHANGES_SOURCE.EXTERNAL]:
          "Aceptas cambios solo desde este origen: Externo"
      },
      [EXTERNAL_CHANGES_STATUS.REJECTED]: {
        title: "Rechazar cambios externos",
        text: "Seleccionar cambios para rechazar en ubicaciones seleccionadas.",
        button: "Rechazar",
        [EXTERNAL_CHANGES_SOURCE.GMB]:
          "Estás rechazando cambios solo de este origen: Google Business Profile Manager",
        [EXTERNAL_CHANGES_SOURCE.EXTERNAL]:
          "Solo rechazas cambios de este origen: External"
      }
    },
    informationalFieldTooltip:
      "El estado de ubicación ha cambiado. Este cambio no se puede rechazar.",
    processingInProgressTooltip:
      "Center AI está actualizando la información de este listado en Google Maps. Durante este proceso no se permiten otros cambios en esta ubicación. Inténtalo de nuevo en unos minutos.",
    fields: {
      [EXTERNAL_CHANGES_FIELD.NAME]: "Nombre de la ubicación",
      [EXTERNAL_CHANGES_FIELD.STREET]: "Calle",
      [EXTERNAL_CHANGES_FIELD.POSTAL_CODE]: "Código postal",
      [EXTERNAL_CHANGES_FIELD.CITY]: "Ciudad",
      [EXTERNAL_CHANGES_FIELD.COUNTRY]: "País",
      [EXTERNAL_CHANGES_FIELD.STORE_CODE]: "Código de tienda",
      [EXTERNAL_CHANGES_FIELD.PRIMARY_CATEGORY]:
        "Categoría principal del negocio",
      [EXTERNAL_CHANGES_FIELD.ADDITIONAL_CATEGORIES]:
        "Categorías comerciales adicionales",
      [EXTERNAL_CHANGES_FIELD.WEBSITE]: "Dirección del sitio web",
      [EXTERNAL_CHANGES_FIELD.PRIMARY_PHONE]: "Teléfono 1",
      [EXTERNAL_CHANGES_FIELD.ADDITIONAL_PHONES]: "Phone 2",
      [EXTERNAL_CHANGES_FIELD.REGULAR_HOURS]: "Horario de apertura",
      [EXTERNAL_CHANGES_FIELD.SPECIAL_HOURS]: "Horario especial de apertura",
      [EXTERNAL_CHANGES_FIELD.ATTRIBUTES]: "Atributos",
      [EXTERNAL_CHANGES_FIELD.DESCRIPTION]: "Descripción",
      [EXTERNAL_CHANGES_FIELD.OPENING_DATE]: "Fecha de apertura",
      [EXTERNAL_CHANGES_FIELD.LOCATION_STATE]:
        "Estado del Administrador de Perfiles de Negocios de Google",
      [EXTERNAL_CHANGES_FIELD.OPEN_STATUS]: "Estado abierto",
      [EXTERNAL_CHANGES_FIELD.LABELS]: "Etiquetas",
      [EXTERNAL_CHANGES_FIELD.MORE_HOURS]: "Más horas",
      [EXTERNAL_CHANGES_FIELD.SERVICES]: "Servicios"
    },
    fieldsTooltips: {
      [EXTERNAL_CHANGES_FIELD.REGULAR_HOURS]:
        "Horario de apertura y más horarios (por ejemplo, horario de entrega)"
    },
    summaryInfoBar:
      "Hemos detectado {changesCount} en tus ubicaciones para rechazar según tu configuración.",
    rejectChanges: "Rechazar cambios",
    changesInfoSection: {
      detectedChanges:
        "Hemos detectado {changesCount} cambios para rechazar (en {facilitiesCount}) para los campos de contenido que deseas proteger.",
      changesRelatedTo: "Estos cambios se refieren a: {fields}.",
      availableHere:
        "Los detalles de todos los cambios detectados están disponibles {link}.",
      here: "aquí",
      confirmReject: "Haz clic abajo si deseas rechazar todos los cambios.",
      noChanges:
        "No se detectaron cambios para rechazar en los campos que deseas proteger.",
      rejectingDialog: "Los cambios detectados están siendo rechazados.",
      rejectDetectedChanges: "Rechazar los cambios detectados",
      rejectConfirmation:
        "¿Estás seguro de que quieres rechazar los cambios detectados?"
    }
  },

  photos: {
    title: "Agregar foto",
    facilityLabel: "La foto se añadirá a",
    facilitiesAll: "todas las ubicaciones (verificadas)",
    facilitiesAllTooltip:
      "Las fotos solo se pueden enviar a ubicaciones verificadas en Google Maps.",
    facilitiesSelected: "ubicaciones seleccionadas (verificadas)",
    facilitiesSelectedTooltip:
      "Las fotos solo se pueden enviar a ubicaciones verificadas en Google Maps. Solo dichas ubicaciones se presentan en la lista en el diálogo abierto.",
    addPhotoTitle: "Foto",
    addPhotoTooltip:
      "Resolución mínima recomendada: <b>720 x 720</b> px.<br/> Tamaño del archivo: entre <b>10 KB</b> y <b>10 MB</b>.<br/> Las fotos de <b>portada</b> deben tener una relación de aspecto de 16:9.",
    addPhoto: "Añadir foto",
    changePhoto: "Cambiar foto",
    categoriesTooltip:
      'Categoría en la que se mostrará una foto en Google Maps. Algunas categorías (por ejemplo, Comida y bebida) podrían no estar disponibles para ciertos tipos de negocios. Si subes una foto a una categoría que no está disponible para ti, entonces esta foto se añadirá automáticamente a la categoría "Otros".',
    send: "Enviar",
    addMore: "Agregar más fotos",
    photoAddedSuccessfully:
      "Se enviaron las fotos. Deberían aparecer en Google Maps en 10 minutos.",
    photosNotAdded:
      "No se enviaron todas las fotos. Por favor, intenta nuevamente con las restantes.",
    facilitiesError: "Se requiere al menos una tarjeta de presentación",
    countLimitError: 'Solo puedes enviar una foto con la categoría "{0}"',
    edit: {
      applyChanges: "Aplicar cambios",
      infoBox: "Redimensiona y adapta el tamaño según tus necesidades.",
      rotateRight: "Girar a la derecha",
      rotateLeft: "Girar a la izquierda",
      reset: "Resetear"
    },
    noData: {
      button: "Agregar cuenta",
      title: "Agregar fotos a ubicaciones en Google Maps",
      desc:
        "Aquí puedes agregar fotos a todas las ubicaciones de tu negocio en Google Maps. Solo necesitas ingresar el contenido de la foto una vez y nosotros lo enviaremos automáticamente a las ubicaciones seleccionadas o a todas tus ubicaciones de negocio. Esto podría ahorrarte mucho tiempo y esfuerzo. Para utilizar esta funcionalidad, importa tus ubicaciones añadiendo tu cuenta de Google a Center AI."
    },
    list: {
      title: "Agregar fotos",
      empty: "Agrega fotos a tus tarjetas.",
      notFound: "No hay fotos en el período de tiempo seleccionado.",
      noPhotos: "Sin fotos",
      addNew: "Añadir nuevo",
      sendDate: "Enviado el",
      mapsStatus: "Estado de la entrada en Google Maps",
      slStatus: "Estado de la entrada en el Localizador de Tiendas",
      sendStatus: "Estado",
      details: "Detalles",
      visible: "Entrada visible",
      sendToFacilities: "Foto enviada a {0}",
      successCount: "{0} publicó",
      failedCount: "{0} rechazado",
      [GMB_MEDIA_TYPE.ADDITIONAL.NAME]: "Adicional",
      [GMB_MEDIA_TYPE.COVER.NAME]: "Cubierta",
      [GMB_MEDIA_TYPE.LOGO.NAME]: "Logotipo",
      [GMB_MEDIA_TYPE.EXTERIOR.NAME]: "Exterior",
      [GMB_MEDIA_TYPE.INTERIOR.NAME]: "Interior",
      [GMB_MEDIA_TYPE.PRODUCT.NAME]: "Producto",
      [GMB_MEDIA_TYPE.FOOD_AND_DRINK.NAME]: "Comida y bebida",
      [GMB_MEDIA_TYPE.TEAMS.NAME]: "Equipo",
      delete: {
        title:
          "¿Estás seguro de que deseas eliminar la foto seleccionada de todas las tarjetas?",
        body1:
          "Esta acción eliminará las fotos en el Administrador de Perfiles de Negocios de Google. A veces, las fotos eliminadas todavía son visibles en Google Maps durante algún tiempo (son eliminadas por Google con un retraso). Esto se debe a la forma en que funcionan los algoritmos de Google y no afecta si la entrada será eliminada por Center AI o directamente en el panel del Administrador de Perfiles de Negocios de Google. Afortunadamente, esta situación es rara.",
        body2: "Eliminar una foto ya no la mostrará en el Store Locator.",
        confirm: "Sí, eliminar",
        tooltip:
          "Para eliminar esta foto, por favor contáctenos a través de correo electrónico (support@center.ai) o a través del chat."
      },
      status: {
        [GMB_MEDIA_STATUS.PENDING]: "Enviando",
        [GMB_MEDIA_STATUS.COMPLETED]: "Enviado",
        [GMB_MEDIA_STATUS.FINISHED_WITH_PROBLEMS]: "Enviado"
      }
    },
    storeLocator: {
      tooltipSwitchOff:
        "La foto añadida no será visible en el Localizador de Tiendas. También puedes cambiar la visibilidad de la foto después de añadirla.",
      tooltipSwitchOn:
        "La foto añadida será visible en Store Locator. También puedes cambiar la visibilidad de la foto después de agregarla."
    }
  },

  posts: {
    fbDialogTitle: "Selecciona la publicación de Facebook que deseas copiar",
    usedForGoogleMapsPost:
      "Se utilizó para crear una publicación en Google Maps",
    copyFacebookPost: "Copiar publicación de Facebook",
    selectPage: "Seleccionar página",
    selectPost: "Seleccionar publicación",
    multimedia: "Multimedia",
    checkOriginalPost: "Ir a la publicación original",
    planning: {
      authorAndDate: "Autor y fecha de creación",
      postsFrom: "Publicaciones de",
      showAllPlannedPosts: "Mostrar todas las publicaciones planeadas.",
      facilitiesSendTooltip:
        "La publicación solo se enviará a las ubicaciones que estaban en el {0} seleccionado en el momento de planificar la publicación. Las ubicaciones que aparezcan en estos {0} más tarde no se incluirán. Además, si pierdes permisos para algunas ubicaciones en el momento en que se envía la publicación, no se enviará a ellas.",
      actionsDisabledTooltip:
        "No tienes permiso para editar esta publicación. Contacta al autor / administrador.",
      info:
        "La publicación solo se enviará a las ubicaciones que estaban en el {0} seleccionado al momento de planificar la publicación.",
      cities: "ciudades",
      groups: "grupos",
      addPostTo: "Añadirás una publicación a",
      emptyText: "No tienes publicaciones programadas.",
      publication: {
        publicationDateTitle: "Fecha de publicación de la publicación",
        publicationDateSubtitle:
          "Selecciona una fecha y hora para publicar la entrada.",
        now: "Ahora",
        tomorrowMorning: "Mañana por la mañana",
        nextWeek: "La próxima semana",
        anotherDate: "Otra fecha"
      }
    },
    scheduledSending: "Envío programado",
    sent: "Enviado",
    list: {
      [POSTS_FORM_TYPE.POST]: "Publicación",
      [POSTS_FORM_TYPE.EVENT]: "Evento",
      [POSTS_FORM_TYPE.OFFER]: "Oferta",
      [POSTS_FORM_TYPE.ALERT]: "Actualización de COVID-19",
      creatingInProgress: "Envío en progreso",
      planned: "Planificado",
      titleTooltip:
        "Aquí puedes ver la lista de publicaciones agregadas con Center AI. Las publicaciones subidas fuera de Center AI (en Google My Business) no serán visibles en este panel.",
      searchFieldPlaceholder: "Buscar publicaciones",
      toogleShowDeletedPosts: "Mostrar las publicaciones eliminadas",
      noPostsAlt: "No hay publicaciones",
      noPostsDescription:
        "No has publicado ninguna publicación en tus listados durante el período seleccionado. \nAgrega una publicación a todos o a algunos listados seleccionados para incentivar a tus clientes a visitar tu tienda y para posicionar tus listados en los resultados de búsqueda de Google Maps.",
      noPhoto: "sin foto",
      clickInButton: 'en botón: "{label}"',
      sendingInProgress: "Enviando en progreso a",
      sendingFinished: "Enviado",
      deletingInProgress: "Eliminación en progreso",
      deleted: "Eliminado",
      sentTo: "Enviado",
      sentDate: "Fecha de envío",
      editDate: "Editar fecha",
      deleteDate: "Eliminar fecha",
      detailsStatusSent: "Enviado {sent_count}/{total_count}",
      sentSuccessCount: "{count} publicado",
      sentErrorCount: "{count} rechazado",
      durationTime: "Tiempo de duración",
      confirmPlannedDeleteDialog: {
        text:
          "¿Estás seguro de que deseas eliminar esta publicación planificada?"
      },
      confirmDeleteDialog: {
        text:
          "¿Estás seguro de que deseas eliminar la publicación de todos los lugares?",
        description:
          "Esta acción eliminará las publicaciones seleccionadas en el Administrador de Perfiles Comerciales de Google. A veces, las publicaciones eliminadas aún pueden ser visibles en Google Maps por un corto período de tiempo (serán eliminadas con retraso). Este problema está relacionado con los algoritmos de Google y puede ocurrir incluso si las publicaciones se eliminan directamente en el panel de Google (Administrador de Perfiles Comerciales). Afortunadamente, dicha situación no es común."
      },
      facilitiesDialog: {
        defaultTitle: "Publicación enviada a las ubicaciones a continuación",
        [POST_BY_FACILITY_STATUS.OK]: {
          title: "Publicación enviada a las ubicaciones a continuación"
        },
        [POST_BY_FACILITY_STATUS.FAILED]: {
          title: "Publicación no enviada a las ubicaciones siguientes"
        },
        fixError: {
          general: "Contáctanos"
        }
      }
    },
    add: {
      [POSTS_FORM_TYPE.POST]: "Agregar publicación",
      [POSTS_FORM_TYPE.EVENT]: "Agregar evento",
      [POSTS_FORM_TYPE.OFFER]: "Agregar oferta",
      [POSTS_FORM_TYPE.ALERT]: "Actualización sobre COVID-19"
    },
    // Add new post related texts below
    addTime: "Agregar tiempo",
    alertHeader: "Notifica a tus clientes",
    facilityLabel: "Las publicaciones se añadirán a",
    facilitiesAll: "todas las ubicaciones (verificadas)",
    facilitiesAllUnverified: "todas las ubicaciones",
    facilitiesAllTooltip:
      "Las publicaciones solo se pueden enviar a ubicaciones verificadas en Google Maps.",
    facilitiesSelected: "ubicaciones seleccionadas (verificadas)",
    facilitiesSelectedUnverified: "ubicaciones seleccionadas",
    facilitiesSelectedTooltip:
      "Las publicaciones solo se pueden enviar a ubicaciones verificadas en Google Maps. Solo dichas ubicaciones se presentan en la lista en el diálogo abierto.",
    mainPhoto: "Foto principal",
    offerName: "Nombre de la oferta",
    postName: "Contenido de la publicación",
    eventName: "Nombre del evento",
    alertName: "Actualiza tu estado",
    startDate: "Fecha de inicio",
    endDate: "Fecha de finalización",
    startTime: "Hora de inicio",
    endTime: "Hora de finalización",
    offerDetails: "Detalles de la oferta",
    offerCode: "Vale (opcional)",
    offerLink: "Enlace a la oferta (opcional)",
    offerTerms: "Términos (opcional)",
    showExtra: "Agregar más detalles (opcional)",
    publish: "Publicar",
    publishFor: "Publicar para {0}",
    preview: "Vista previa",
    schedule: "Detalles del evento",
    postUrl: "URL",
    callToAction: {
      label: "Agregar botón (opcional)",
      [POSTS_CALL_TO_ACTION_TYPE.BOOK]: "Libro",
      [POSTS_CALL_TO_ACTION_TYPE.ORDER]: "Pedir en línea",
      [POSTS_CALL_TO_ACTION_TYPE.SHOP]: "Comprar",
      [POSTS_CALL_TO_ACTION_TYPE.LEARN_MORE]: "Más información",
      [POSTS_CALL_TO_ACTION_TYPE.SIGN_UP]: "Regístrate",
      [POSTS_CALL_TO_ACTION_TYPE.CALL]: "Teléfono ahora"
    },
    alertTitle: "¿Cambios en tu negocio?",
    alertSubtitle:
      "Informa a tus clientes sobre los cambios recientes en tu negocio como resultado de las restricciones por COVID-19.",
    noData: {
      button: "Agregar cuenta",
      title: "Agregar publicación a ubicaciones en Google Maps",
      desc:
        "Aquí puedes añadir publicaciones a todos tus perfiles de ubicación en Google Maps. Solo necesitas ingresar el contenido de la publicación una vez y nosotros lo enviaremos automáticamente a las ubicaciones seleccionadas o a todas tus ubicaciones comerciales. Esto podría ahorrarte mucho tiempo y esfuerzo. Para utilizar esta funcionalidad, importa tus ubicaciones añadiendo tu cuenta de Google a Center AI."
    },
    addImage: "Agregar foto",
    addImageTooltip:
      "La foto debe estar en formato PNG o JPG. La proporción recomendada de la foto es 4:3. La resolución mínima es de 400 x 300 px y el tamaño debe ser de 10 kB. La resolución máxima recomendada es de 8000 x 6000 px y el tamaño de 10 MB.",
    postSuccess: "La publicación fue enviada. Aparecerá pronto en Google Maps.",
    postPlannedSuccess:
      "La publicación fue enviada. Debería aparecer en Google Maps {0}.",
    select: "Seleccionar",
    facilitiesError: "Por favor, selecciona al menos una ubicación.",
    published: "Publicado",
    selectedFacilities: "{facilitiesCount} seleccionados",
    selectedCities: "{citiesCount} seleccionados ({facilitiesCount})",
    selectedFacilitiesGroups:
      "{facilitiesGroupsCount} seleccionados ({facilitiesCount})",
    changeButton: "Cambiar",
    viewButton: "Ver",
    facilitiesToAddDialog: {
      title: "El correo se enviará a las ubicaciones siguientes.",
      noFacilities: "No se han elegido ubicaciones"
    },
    successfullyDeleted: "La publicación fue eliminada.",
    postsGuideBtn: "Publicaciones - Guía",
    storeLocator: {
      visibilityStatus: "Estado de la publicación en Store Locator",
      tooltipSwitchOff:
        "La publicación agregada no será visible en el Localizador de Tiendas. La visibilidad de la entrada también se puede cambiar después de haber sido agregada.",
      tooltipSwitchOn:
        "La publicación añadida será visible en el Localizador de Tiendas. La visibilidad de la entrada también se puede cambiar después de que haya sido añadida."
    },
    postVisibility: "Publicar visible",
    visibleGoogleMaps: "Para Google Maps",
    visibleStoreLocator: "Localizador de Tiendas"
  },

  reviews: {
    aiReply: {
      packetCloseToLimitTooltip:
        "Para aumentar su paquete, por favor contáctenos.",
      onlyTextTooltip: "Puede usarse solo para reseñas con texto",
      outOfLimitTooltip:
        "Este mes, no es posible generar respuestas utilizando IA, ya que se ha agotado el paquete disponible. El paquete se renovará al inicio del mes. Para aumentar su paquete, por favor contáctenos.",
      error: "Respuesta de error de la IA.",
      replyWithAi: "Responde con IA",
      generateAgain: "Generar de nuevo",
      repliesLeft: "Respuestas restantes",
      generateWithAi: "Generando respuesta con IA",
      settingsAiReply: "Configuración de respuesta de IA",
      instructionsForAi: "Instrucciones para IA",
      aiSettingsTip1:
        "Cómo funciona: Aquí puedes ingresar opcionalmente instrucciones adicionales que la IA utilizará al generar sugerencias de respuesta para reseñas. Las instrucciones pueden referirse a cualquier aspecto, como el estilo de habla, el uso de palabras o frases específicas, etc. A continuación se muestra un ejemplo de dichas instrucciones.",
      aiSettingsTip2:
        "Gracias por comprar en nuestra tienda. ¡Esperamos tu próxima visita!"
    },
    findPhrase: "Encontrar frase",
    periods: {
      weekly: "Semanalmente",
      monthly: "Mensualmente"
    },
    chart: {
      averageRateForCategory:
        "Tasa promedio en la categoría “{0}” para el período dado",
      reviewsCountForCategory:
        "Recuento de reseñas en la categoría “{0}” para el período dado"
    },
    dialogs: {
      howDoesAutomaticCategorizationWork:
        "¿Cómo funciona la categorización automática?",
      contact: "Contáctenos",
      autoCategorizeOldReviews:
        "Después de habilitar la categorización automática, las categorías se asignan solo a las nuevas reseñas (aquellas que aparecerán en el futuro). Si también desea categorizar automáticamente las reseñas más antiguas, por favor contáctenos.",
      addPhrasesToCategoryTitle: "Agregar frases a la categoría",
      addPhrasesToCategoryContent: `Agrega frases a la categoría (por ejemplo, "caro" a la categoría Precio). Gracias a esto, el sistema podrá asignar automáticamente esta categoría a la opinión.`,
      alertBeforeActionFirstLine: `Has realizado los siguientes cambios en la categoría “{0}”:`,
      alertBeforeActionLastLine: `¿Está seguro de que desea guardar los cambios? Provocarán cambios en las reseñas existentes y futuras que contengan las siguientes frases.`,
      autoCategorizationTitle: `Clasificación automática de reseñas y análisis de sentimientos`,
      autoCategorizationContent: `El Center Al puede asignar automáticamente categorías (por ejemplo, "atención al cliente") a cada reseña relacionada. Esto se realiza mediante el análisis del contenido de la reseña. Además, para cada categoría detectada, se determina su sentimiento, indicando el tono emocional (positivo, neutral, negativo). 

Para utilizar la categorización automática y el análisis de sentimiento, solo necesitas:

• Definir las categorías que deben ser detectadas. El sistema solo asigna reseñas a las categorías añadidas al Center Al (no detecta categorías adicionales por sí mismo).

• Habilitar la categorización automática de reseñas y el análisis de sentimientos para las categorías seleccionadas.

Ambas acciones se pueden realizar en la pantalla de gestión de categorías.`,
      manageAlerts: {
        add: `Has añadido {0} frases.`,
        delete: `Has eliminado {0} frases.`,
        update: `Has actualizado {0} frases.`
      },
      alertAfterEditTitle: ``,
      alertAfterEditContent: `Has realizado cambios en las frases para la categoría “{0}”, pero no has activado la categorización automática. </br> <b> ¿Quieres habilitar la categorización automática para esta categoría? </b>`
    },
    allPhrases: "Todas las frases",
    autCategorizationEnabled: "La categoría fue asignada automáticamente.",
    autoCategorizationLabel:
      "La categoría tiene la categorización automática habilitada.",
    autoCategorization: "Categorización automática",
    allCategories: "Todas las categorías",
    phraseList: "Lista de frases",
    categoryAssignTitle: "¿Sobre qué tratan estas opiniones?",
    categoryAssignSubtitle:
      "Selecciona las categorías que deseas asignar a las reseñas seleccionadas.",
    enterNewCategory: "Ingresar nueva categoría",
    enterNewPhrase: "Introduce nueva frase",
    reviews: "Reseñas",
    reviewsList: "Lista de reseñas",
    reviewsWith: "Reseñas:",
    replyPublished: "Respuesta publicada",
    replyRejected: "Respuesta rechazada",
    header: "Reseñas de lugares",
    all: "Todo",
    tip:
      "Aquí puedes ver todas las reseñas de cada una de tus ubicaciones. Puedes elegir responder a una o varias reseñas a la vez utilizando una plantilla de respuesta. Para encontrar rápidamente reseñas específicas por palabras clave o incluso una frase completa, usa nuestro navegador a continuación o el filtro en la esquina derecha. Asegúrate de responder primero a las “reseñas más relevantes“, ya que se encuentran en la parte superior de los resultados de búsqueda de Google Maps.",
    answered: "Respondido",
    answer: "Responder",
    assignCategories: "Asignar categorías",
    answerBtn: "Responde ahora",
    unanswered: "Sin respuesta",
    onlyComments: "Reseñas con contenido",
    onlyNotes: "Reseñas con una nota",
    showDeletedReviews: "Mostrar reseñas eliminadas",
    onlyUpdated: "Reseñas editadas durante el período seleccionado",
    onlyCreated: "Reseñas creadas durante el período seleccionado",
    addedToGoogle: "Dodane do Map Google",
    writtenWithAI: "Escrito con la ayuda de un asistente de IA.",
    onlyNoComments: "Reseñas sin contenido",
    onlyAccurate: "Reseñas más relevantes",
    opinions: "Reseñas",
    actions: "Acciones",
    noComment: "El usuario solo ingresó una calificación.",
    noData:
      "No hemos encontrado reseñas en tus listados para el período seleccionado. Selecciona un rango de fechas diferente o espera a que se obtengan reseñas.",
    totalReviewsCount: "Todas las reseñas: {0}",
    withReplyReviewsCount: "Con respuesta: {0}",
    withoutReplyReviewsCount: "Sin respuesta: {0}",
    percentageOfAllReviews: "{0}% de todas las reseñas",
    yourAnswer: "Tu respuesta",
    publishAnswer: "Publicar respuesta",
    reviewsAIReplyList: "Lista de reseñas con respuestas de IA",
    suggestedAnswerByAI: "Respuesta sugerida por la IA",
    noSuggestedAnswerByAI:
      "Por el momento, no hay respuestas sugeridas por IA para la opinión.",
    cancel: "Cancelar",
    edit: "Editar",
    editAndResend: "Editar y reenviar",
    delete: "Borrar",
    filter: "Filtrar",
    owner: "Respuesta del propietario",
    city: "Ciudad",
    cities: "Ciudades",
    facilities: "Ubicaciones",
    facilitiesGroups: "Grupos de ubicaciones",
    rating: "Calificación",
    save: "Guardar",
    dateRange: "Intervalo de fechas",
    more: "Más",
    addedLabel: "Añadido",
    deletedLabel: "Revisión eliminada",
    accurateLabel: "Reseña más relevante",
    accurateTooltip:
      "Las reseñas más relevantes son aquellas que Google destaca y muestra en la página principal de la ficha de tu Google Maps. Estas son las reseñas que tus clientes ven primero.",
    search: "Buscar ubicaciones",
    searchCity: "Buscar ciudad",
    searchFacilitiesGroups: "Grupos de ubicaciones de búsqueda",
    deleteReplyConfirm: "¿Está seguro de que desea eliminar la respuesta?",
    userDataHidden: "Los datos del usuario están ocultos.",
    noFacilities: {
      button: "Agregar cuenta",
      title: "Ver y responder a las opiniones de tus clientes",
      desc:
        "Aquí puedes navegar de manera fácil y conveniente las reseñas de tus clientes en Google Maps y comunicarte con ellos. Para utilizar esta funcionalidad, importa tus ubicaciones añadiendo tu cuenta de Google."
    },
    analyst: {
      title: "Análisis de calificaciones",
      subtitleSummary: "Resumen",
      subtitleSummaryTooltip:
        "Este panel te permite navegar por todas tus calificaciones de Google Maps obtenidas desde que se crearon tus ubicaciones. Aquí puedes comparar las calificaciones de diferentes periodos para llegar a conclusiones sobre cómo te perciben tus clientes en contextos específicos y en general. Permite que tus gerentes regionales o de tiendas tengan acceso a esta función para ayudarles a monitorear la retroalimentación de los clientes y aplicar los cambios necesarios.",
      subtitleRatings: "Distribución de calificaciones",
      subtitleRatingsTooltip:
        "Resumen de calificaciones de ubicaciones seleccionadas dentro del período de tiempo específico.",
      subtitleComparison: "Datos de ubicaciones",
      subtitleHistory: "Historia",
      averageRating: "Calificación promedio",
      averageRatingTooltip:
        "La calificación promedio de las ubicaciones seleccionadas dentro del período de tiempo específico.",
      totalRatingCount: "Calificaciones en total",
      noDataDescription:
        "Actualmente estamos recopilando datos. La información estará disponible aquí en aproximadamente 1 hora.",
      totalRatingCountTooltip:
        "Número total de calificaciones de ubicaciones seleccionadas dentro del período de tiempo específico.",
      gmbAddress: "Ubicación",
      averageRatingFromBegin: "Calificación promedio en total",
      ratingCountFromBegin: "Calificaciones en total",
      newRatingCount: "Calificaciones en total",
      reviews: "Calificaciones",
      selectedPeriod: "Período seleccionado ({0})",
      period: "Periodo",
      comparedPeriod: "Período comparado ({0})",
      allReviews: "Todas las calificaciones",
      noFacilities: {
        title:
          "Examinar datos de análisis sobre las calificaciones de tus clientes",
        desc:
          "Aquí puedes analizar fácilmente las calificaciones de Google Maps con respecto a tus ubicaciones verificando la distribución de las clasificaciones dentro de un período seleccionado y comparándolas con el período anterior. Para usar esta funcionalidad, importa tus ubicaciones agregando una cuenta en Google Business Profile Manager."
      },
      includedRatings: "Calificaciones incluidas",
      allRatingsIncluded:
        "Todas las calificaciones añadidas o editadas en el período seleccionado.",
      newRatingsIncluded:
        "Solo las calificaciones añadidas en el período seleccionado. Las calificaciones editadas en este período no están incluidas.",
      editedRatingIncluded:
        "Solo las calificaciones editadas en el período seleccionado. Las calificaciones añadidas en este período no están incluidas."
    },
    replyTemplates: {
      title: "Plantillas de respuesta",
      use: "Usar",
      useTemplate: "Usar plantilla",
      chooseTemplate: "Seleccionar plantilla de respuesta",
      replyError: "Error al enviar la respuesta",
      categories: {
        noCategoriesDescription:
          "Añade y categoriza plantillas de respuesta para mejorar tu efectividad al responder a las reseñas de tus clientes.",
        [DIALOG_MANAGE_MODE.ADD]: "Agregar categoría",
        [DIALOG_MANAGE_MODE.EDIT]: "Editar categoría",
        categoryNamePlaceholder: "Nombre de la categoría",
        category: "Nombre de categoría",
        repliesCount: "Cantidad de plantillas",
        createdBy: "Creado por",
        viewButton: "Ver plantillas",
        save: "Guardar"
      },
      templates: {
        [DIALOG_MANAGE_MODE.ADD]: "Agregar plantilla",
        [DIALOG_MANAGE_MODE.EDIT]: "Editar plantilla",
        category: "Categoría",
        templateTextPlaceholder: "Texto de respuesta",
        noTemplates: "No hay plantillas de respuesta en esta categoría",
        backToList: "Atrás",
        save: "Guardar"
      }
    },
    tags: {
      tags: "Categorías",
      manageTagsBasic: "Gestionar categorías",
      manageTags: "Gestionar categorías de reseñas",
      typeNewTag: "Introducir una nueva categoría",
      addedTags: "Categorías añadidas",
      noTagsDescription: "Aún no tienes ninguna categoría.",
      noTagsFilterDialogText:
        "Actualmente no tienes categorías añadidas. Proporciona algunas para poder filtrarlas.",
      addDescription:
        "Escríbelos en el campo de arriba, haz clic en 'Enter' o 'Agregar' para añadirlos a tu lista de categorías.",
      selectTagsDescription:
        "Haz clic en las categorías anteriores para añadirlas a la opinión seleccionada.",
      selectTags: "Seleccionar categorías",
      selected: "Seleccionado",
      reviewTags: "¿De qué trata esta reseña?",
      noTagsAssigned: "No hay categorías asignadas",
      noTagsSelected: "No se seleccionaron categorías",
      noTagsAvailable:
        "Para añadir una categoría a tu reseña, primero debes definir las categorías disponibles.",
      defineTagsHere: "Define categorías aquí.",
      noPermissions:
        "No tienes permisos para definir categorías de reseñas. \nContacta al administrador de la cuenta o al propietario.",
      tagDeleteAlert:
        "¿Está seguro de que desea eliminar la categoría <b>{0}</b>? También se eliminará de todas las reseñas."
    },

    bulkReply: {
      heading: "Respuesta masiva",
      btnLabel: "Respuesta masiva",
      infoBoxLabel:
        "Agregaremos la respuesta a continuación a cada una de las reseñas seleccionadas.",
      infoBoxLabel2:
        "Las reseñas que ya tienen una respuesta se omitirán (las respuestas no se cambiarán).",
      bulkReplyPlaceholder: "Tú respondes",
      saveBtnLabel: "Publicar respuesta",
      replyInProgress: "Envío de respuesta en progreso",
      replyInProgressTooltip:
        "Su respuesta se está publicando en Google Maps. No tomará mucho tiempo. Para verificar si la respuesta se ha publicado, actualice esta página o regrese aquí en unos minutos.",
      selectCustomReply: "Ingrese manualmente",
      selectTemplateReply: "Elige plantillas de respuesta",
      templateInfoBoxLabel:
        "Si eliges más de una plantilla, asignaremos las respuestas al azar.",
      category: "Categoría",
      all: "Todo"
    },
    sort: "Ordenar",
    ratingDesc: "Clasificación: de más alto a más bajo",
    ratingAsc: "Clasificación: de menor a mayor",
    createDateDesc: "Fecha: más reciente primero",
    createDateAsc: "Fecha: de más antigua a más reciente",
    selectedPeriod: "Período seleccionado",
    categories: {
      showOnlyAutoAssignedCategories:
        "Mostrar solo categorías asignadas automáticamente",
      ratingsInCategory: "Calificaciones en la categoría {0}",
      averageRateTooltip: "Calificación promedio",
      allLocations: "Todas las ubicaciones",
      selectLocations: "Seleccionar ubicaciones",
      locationsGroup: "Grupo de ubicaciones",
      selectedPeriod: "Periodo seleccionado",
      comparedPeriod: "Período comparado",
      sentiment: "Sentimiento",
      generalSentiment: "Sentimiento general",
      sentimentChange: "Confirmar cambio",
      changeAnyway: "Cambiar",
      makeChange: "Cambiar",
      sentimentChangeAlert: `La categoría y el sentimiento fueron asignados automáticamente por nuestro asistente de IA en función del contenido de la reseña. Si cree que la asignación es incorrecta, puede cambiarla. ¿Le gustaría hacer un cambio?`,
      sentimentRateInPeriod: `Tasa de sentimiento en la categoría "{0}" en el período comparado`,

      gridColumns: {
        categories: "Categoría",
        averageRateInPeriod: "Tasa promedio en el período",
        countInComparisonPeriod: "Número de opiniones en el período comparado",
        reviewsCount: "Opiniones en total",
        averageRateInComparisonPeriod: "Tasa promedio en el período comparado",
        averageRateFromBeginning: "Promedio desde el principio",
        reviewsCountInPeriod: "Opiniones en total",
        rates: "Calificaciones",
        actions: "Acciones",
        sentiment: {
          sentimentScoreTooltip: `NSS (Net Sentiment Score). NSS te permite evaluar el sentimiento general de las reseñas. Varía de -100 (cuando todas las reseñas tienen un sentimiento negativo) a 100 (cuando todas las reseñas tienen un sentimiento positivo). NSS se calcula usando la fórmula: 'porcentaje de reseñas con sentimiento positivo' - 'porcentaje de reseñas con sentimiento negativo'.`,
          positive: "Sentimiento positivo",
          negative: "Sentimiento negativo",
          neutral: "Sentimiento neutral",
          unassigned: "Sentimiento no asignado",
          sentimentInSelectedPeriod: "Sentimiento en el periodo seleccionado",
          sentimentInComparisonPeriod:
            "Sentimiento en el período de comparación",
          sentimentFromBeginning: "Sentimiento desde el principio"
        }
      },
      citySearchPlaceholder: "¿Qué ciudad estás buscando?",
      groupSearchPlaceholder: "¿Qué grupo estás buscando?",
      facilitySearchPlaceholder: "¿Qué ubicación estás buscando?",
      title: "Análisis de categorías de reseñas",
      dataFor: "Datos para",
      allFacilities: "Todas las ubicaciones",
      selectFacilities: "Seleccionar ubicaciones",
      selectedRange: "En el rango seleccionado",
      fromBegin: "Desde el principio",
      inGivenPeriod: "En el período comparado",
      averageRate: "Calificación promedio",
      reviewsCount: "Número de reseñas",
      ratings: "Calificación",
      positive: "Positivo",
      negative: "Negativo",
      chartDescription: `El mapa de calor a continuación ilustra las reseñas de los clientes por categorías. Cuanto más grande es el rectángulo, más reseñas se compartieron. El color refleja la calidad de las reseñas, según la leyenda a continuación (verde oscuro- el mejor, a rojo oscuro- el peor).`,
      compare: "Comparar",
      comparedTo: "en comparación con",
      categorySearchLabel: "¿Qué categoría estás buscando?",
      averageRateHigherTooltip: `La calificación promedio en el período seleccionado mejoró en relación con el número de calificaciones desde el inicio.`,
      sentimentRateHigherTooltip: `El sentimiento en el período seleccionado mejoró en comparación con el sentimiento desde el principio.`,
      sentimentRateComparisonHigherTooltip: `El sentimiento en el período seleccionado mejoró en relación con el sentimiento desde el principio.`,
      countRateHigherTooltip: `La cuenta de tasas en el período seleccionado mejoró en relación con la cuenta de tasas en el período comparado.`,
      averageRateLowerTooltip: `La calificación promedio en el período seleccionado empeoró en relación con la calificación promedio desde el principio.`,
      sentimentRateLowerTooltip: `La calificación de sentimiento en el período seleccionado empeoró en relación con el sentimiento desde el comienzo.`,
      sentimentRateComparisonLowerTooltip: `La calificación de sentimiento en el período seleccionado empeoró en relación con el sentimiento desde el principio.`,
      countRateLowerTooltip: `La cuenta de la tasa en el período seleccionado empeoró en relación con la cuenta de la tasa en el período comparado.`,
      ratesInPeriodTitle: "Reseñas en categorías",
      facilitiesRatesInPeriodTitle: "Calificaciones en instalaciones",

      filters: {
        yesterday: "Ayer",
        last7Days: "Últimos 7 días",
        last30Days: "Últimos 30 días",
        last90Days: "Últimos 90 días",
        last180Days: "Últimos 180 días",
        last365Days: "Últimos 365 días",
        lastWeek: "Semana pasada",
        lastMonth: "Mes anterior",
        lastQuarter: "Trimestre anterior",
        last6Months: "Últimos 6 meses",
        lastYear: "Año anterior",
        fromBeginning: "Desde el principio",
        previousTerm: "Período anterior",
        previousYear: "Año anterior"
      },
      facilityDialog: {
        title: "Seleccionar ubicación",
        allFacilitiesTitle: `Mostrar todas las ubicaciones de una empresa:`,
        allFacilitiesFooter: `El usuario siempre tendrá acceso a todas las tarjetas de presentación, incluidas aquellas que se agregarán a la empresa en el futuro.`
      }
    }
  },

  permissions: {
    usersTooltip:
      "Aquí puedes agregar nuevos miembros al equipo y definir sus permisos.",
    tooltip:
      "Para cambiar la ubicación, haz clic en el menú desplegable de arriba y selecciona una ubicación diferente.",
    permissions: "Permisos",
    selectedCompany: "Empresa seleccionada",
    addNewUser: "Agregar un nuevo usuario",
    addUserToTeam: "Agregar usuario al equipo",
    addUser: "Agregar usuario",
    team: "Equipo",
    users: "Usuarios",
    youAreOwner: "Eres el propietario",
    youAreAdmin: "Tienes acceso completo",
    youAreManager: "Tienes acceso limitado",
    email: "Correo electrónico",
    emailAddress: "Dirección de correo electrónico",
    teamInvitation: "Estado de la invitación",
    accountType: "Tipo de cuenta",
    accountTypes: {
      [AccountType.OWNER]: "Propietario",
      [AccountType.ADMIN]: "Acceso completo",
      [AccountType.MANAGER]: "Acceso limitado"
    },
    managerTooltip:
      "Los usuarios con acceso limitado solo tienen acceso a las ubicaciones seleccionadas por ti y pueden realizar solo las acciones seleccionadas por ti. Estas acciones y ubicaciones se definirán en los siguientes pasos.",
    adminTooltip:
      "Los usuarios con acceso completo tienen acceso a todas las acciones y a todas las ubicaciones. Además, pueden añadir y eliminar ubicaciones, importar ubicaciones desde Google Business Profile Manager, así como agregar, eliminar o restringir los permisos de otros usuarios.",
    invitationStatus: {
      active: "Acceso concedido",
      pending: "Esperando la aceptación de la invitación"
    },
    see: "Ver permisos",
    all: "Todas las ubicaciones",
    resend: "Reenviar",
    noUsers:
      "¿Necesitas ayuda para gestionar tus ubicaciones? ¡Autoriza a los miembros de tu equipo para administrar las ubicaciones!",
    invitationSent: "La invitación ha sido reenviada",
    accountDeleted: "El usuario fue eliminado del equipo.",
    permissionsGranted: "Se han concedido permisos",
    access: "Acceso",
    accessTo: "Acceso a",
    allFacilities: "todas las ubicaciones",
    allPermissions: "sin restricciones",
    limitedPermissions: "restringido",
    invitationEmailInfo:
      "* se envió una invitación para unirse a tu equipo a la dirección de correo electrónico que proporcionaste",
    facilitiesInGroupTitle: "Ubicaciones en grupo",
    facilitiesPermissionsTitle: "Seleccionar ubicaciones para otorgar acceso",
    editFacilitiesPermissionsTitle: "Editar acceso a la ubicación",
    previewFacilitiesPermissionsTitle: "Acceso a la ubicación",
    facilitySearchPlaceholder: "¿Qué ubicación estás buscando?",
    facilityGroupSearchPlaceholder: "¿Cuál grupo estás buscando?",
    facilitiesList: "Lista de ubicaciones",
    facilitiesGroups: "Grupos de ubicaciones",
    selected: "Ubicaciones seleccionadas",
    selectedAll: "Todas las ubicaciones",
    selectedGroups: "Grupos seleccionados",
    userAccessAllTo: "El usuario tendrá acceso a todas las ubicaciones en:",
    accessAllFutureInfo:
      "* el usuario tendrá acceso a todas las ubicaciones, incluidas aquellas ubicaciones que puedan añadirse a su empresa más adelante",
    userPermissions: "Permisos de usuario",
    editUserPermissions: "Editar permisos de usuario",
    noMembers:
      "¿Necesitas ayuda para gestionar tus ubicaciones?\n ¡Autoriza a los miembros de tu equipo para gestionar ubicaciones!",
    atLeastOneFacilityRequired: "Por favor, selecciona al menos una ubicación",
    editAccountType: "Editar tipo de cuenta",
    backToPermissions: "Volver a los permisos",
    addCompanyAsOwner: "Agregar nueva empresa"
  },

  permissionsData: {
    group: {
      name: {
        basic: "Permisos básicos",
        photos: "Fotos",
        gmbEdit: "Editando ubicaciones en Google Maps",
        externalChanges: "Gestionar cambios externos",
        gmbPosts: "Publicación en ubicaciones en Google Maps",
        gmbReviews: "Reseñas de ubicaciones en Google Maps",
        gmbAnalytics: "Analítica para ubicaciones en Google Maps",
        storeLocator: "Localizador de tiendas",
        questionsAndAnswers: "Preguntas y respuestas",
        reviewBooster: "Review Booster"
      }
    },
    name: {
      viewDashboard: "Ver el panel de control",
      viewFacilitiesData: "Ver ubicaciones",
      viewCompanyData: "Ver información de la empresa",
      manageCompanyData: "Editar información de la empresa",
      editFacilityName: "Editar nombre",
      editFacilityAddress: "Editar dirección",
      editFacilityStoreCode: "Editar código de tienda",
      editFacilityWebsite: "Editar sitio web",
      editFacilityPhoneNumber: "Editar número de teléfono",
      editFacilityServiceItems: "Servicios de edición",
      editFacilityOpeningDate: "Editar fecha de apertura",
      editFacilityDescription: "Editar descripción",
      editFacilityAttributes: "Editar atributos",
      editFacilityPrimaryCategory: "Editar categoría principal",
      editFacilityAdditionalCategories: "Editar categorías adicionales",
      editFacilityLabels: "Editar etiquetas",
      editFacilityHours: "Editar el horario de apertura",
      editFacilityOpenStatus: "Editar estado abierto / cerrado",
      editReviewReplyTemplates: "Editar plantillas de respuesta",
      viewExternalChanges: "Ver cambios externos",
      approveAndRejectExternalChanges: "Aprobar y rechazar cambios externos",
      viewExternalChangesHistory: "Ver historial de cambios externos",
      protectFromExternalChanges:
        "Administrar la protección contra cambios externos",
      addAndDeletePhotos: "Agregar y eliminar fotos",
      viewPhotos: "Ver lista de fotos",
      viewLocalPosts: "Ver lista de publicaciones",
      addAndDeleteLocalPosts: "Agregar y eliminar publicaciones",
      viewReviewsAnalytics: "Ver análisis de reseñas",
      viewReviews: "Ver reseñas",
      replyReviews: "Responder a las reseñas",
      viewGmbInsights:
        "Ver análisis del Administrador de Perfiles de Negocios de Google",
      viewMapsRankings: "Ver posiciones de tus ubicaciones en Google Maps",
      viewMapsCompetitionRankings:
        "Ver las ubicaciones de tus competidores en Google Maps",
      manageCompetitionPlaces:
        "Administrar las ubicaciones de los competidores",
      manageKeywords:
        "Gestionar palabras clave que están siendo monitoreadas en búsquedas de Google Maps",
      manageGmbAccount:
        "Importar ubicaciones desde Google Business Profile Manager",
      manageExternalGmbAddresses:
        "Importar ubicaciones desde fuera de Google Business Profile Manager",
      viewTeam: "Ver miembros del equipo",
      manageTeam: "Gestionar equipo",
      manageReviewsCategories: "Administrar categorías",
      assignReviewsCategories: "Administrar categorías de reseñas",
      manageStoreLocator: "Administrar el Localizador de Tiendas",
      configureAiReviewReply: "Configuración de la respuesta de revisión de IA",
      viewQAndA: "Ver preguntas y respuestas",
      addAndEditQAndA: "Agregar y editar preguntas y respuestas",
      deleteQAndA: "Eliminar preguntas y respuestas",
      viewRbReviews: "Ver reseñas",
      viewRbReviewsAnalytics: "Ver análisis de reseñas",
      viewRbForms: "Ver formularios"
    },
    tooltip: {
      viewFacilitiesData: "Ver lista de ubicaciones (sin permiso de edición)",
      viewCompanyData:
        'Mostrar información de la empresa (en la página "Mi Empresa")',
      editFacilityHours:
        "Edita el horario regular de apertura, horas especiales (por ejemplo, horario de apertura en días festivos) y más horarios (por ejemplo, horas de entrega).",
      editFacilityOpenStatus: "Establecer la ubicación como abierta o cerrada",
      editFacilityOpeningDate: "Editar la fecha de apertura de la ubicación",
      editFacilityAttributes:
        "Editar atributos de ubicación. Los atributos comprenden información como métodos de pago, accesibilidad o Wi-Fi gratuito.",
      manageCompetitionPlaces:
        "Agregar y eliminar ubicaciones de competidores monitorizadas por Center AI",
      manageKeywords:
        "Agregar y eliminar palabras clave que se están monitoreando en las búsquedas de Google Maps.",
      manageGmbAccount:
        "Gestión de cuentas de Google en Center AI (añadir y eliminar cuentas) e importar ubicaciones de estas cuentas de GMB a Center AI",
      manageExternalGmbAddresses:
        "Importar o eliminar ubicaciones de Center AI que no están asociadas con cuentas de Google. Estas ubicaciones no se pueden editar, pero es posible monitorizarlas.",
      viewTeam: "Ver miembros del equipo",
      manageTeam:
        "Invitar a nuevos miembros a unirse a tu equipo, eliminar miembros del equipo, conceder y restringir los permisos de cada miembro del equipo.",
      manageCompanyData:
        'Mostrar información de la empresa (en la página "My Company") y ver y gestionar el plan de suscripción de Center AI (en la página "Account Settings").'
    }
  },

  demoService: {
    language: {
      description: "Esta cuenta está disponible solo en español."
    },
    modal: {
      text:
        "Esta es una versión de demostración de Center AI. No está permitido modificar los datos. Crea una cuenta gratuita para tener acceso completo a todas las funciones.",
      buttonText: "OK"
    }
  },
  meta: {
    login: {
      title: "App Center AI - inicio de sesión",
      description:
        "Inicia sesión en el panel de administración de listas de Google Business Profile Manager"
    },
    signUp: {
      title:
        "Gestiona servicios en Google Business Profile Manager y sé el primero en Google Maps | Center AI",
      description:
        "Analiza datos, monitorea cambios, gestiona información y optimiza la visibilidad de las ubicaciones de tu negocio en Google Maps desde un panel fácil de usar."
    }
  },
  menuLabels: {
    [Module.DASHBOARD]: "Panel de control",
    [Module.POSITION_MONITORING]: "Monitoreo de clasificación en Google Maps",
    [Module.POSITION_SINGLE_LOCATION]:
      "Clasificación - ubicaciones individuales",
    [Module.POSITION_ALL_LOCATIONS]: "Clasificación - todas las ubicaciones",
    [Module.POSITION_COMPETITION_COMPARISON]: "Comparación con la competencia",
    [Module.USERS_BEHAVIOR]: "Acciones de los usuarios en Google Maps",
    [Module.ANALYTICS_COMPARISON]: "Compara los listados de Google Maps.",
    [Module.LOCATIONS]: "Ubicaciones",
    [Module.LOCATIONS_MANAGE]: "Gestión de ubicaciones",
    [Module.LOCATIONS_QUALITY]: "Calidad de ubicaciones",
    [Module.EXTERNAL_CHANGES]: "Cambios externos",
    [Module.EXTERNAL_CHANGES_LIST]: "Lista de cambios",
    [Module.EXTERNAL_CHANGES_PROTECT]: "Protección contra cambios",
    [Module.EXTERNAL_CHANGES_HISTORY]: "Historial de cambios",
    [Module.PHOTOS]: "Fotos",
    [Module.POSTS]: "Publicaciones",
    [Module.REVIEWS]: "Opiniones",
    [Module.REVIEWS_LIST]: "Lista de reseñas",
    [Module.REVIEWS_ANALYTICS]: "Análisis de calificaciones",
    [Module.REVIEWS_CATEGORIES_ANALYTICS]: "Análisis de categorías de reseñas",
    [Module.TEAM]: "Equipo",
    [Module.SETTINGS]: "Configuración",
    [Module.SETTINGS_COMPANY]: "Tu empresa",
    [Module.SETTINGS_KEYWORDS]: "Palabras clave monitoreadas",
    [Module.SETTINGS_COMPETITION_LOCATIONS]: "Ubicaciones de los competidores",
    [Module.SETTINGS_GMB_ACCOUNTS]: "Cuentas de Google",
    [Module.SETTINGS_FACEBOOK_ACCOUNTS]: "Cuentas de Facebook",
    [Module.SETTINGS_APPLE_ACCOUNTS]: "Cuentas de Apple",
    [Module.SETTINGS_MAP_CONFIG]: "Configuración del mapa",
    [Module.SETTINGS_APPS_CONFIG]: "Configuración de aplicaciones",
    [Module.STORE_LOCATOR]: "Localizador de Tiendas",
    [Module.REVIEW_BOOSTER]: "Reseñas de Review Booster",
    [Module.REVIEW_BOOSTER_FORM_LIST]: "Formularios",
    [Module.REVIEW_BOOSTER]: "Review Booster",
    [Module.REVIEW_BOOSTER_REVIEWS]: "Respuestas de formularios",
    [Module.QUESTIONS_AND_ANSWERS]: "Preguntas y respuestas"
  },
  weekDaysShort: {
    [WEEK_DAYS.Monday]: "Lun",
    [WEEK_DAYS.Tuesday]: "Mar",
    [WEEK_DAYS.Wednesday]: "Mié",
    [WEEK_DAYS.Thursday]: "Jue",
    [WEEK_DAYS.Friday]: "Vie",
    [WEEK_DAYS.Saturday]: "Sáb",
    [WEEK_DAYS.Sunday]: "Dom"
  },
  weekDays: {
    [WEEK_DAYS.Monday]: "Lunes",
    [WEEK_DAYS.Tuesday]: "Martes",
    [WEEK_DAYS.Wednesday]: "Miércoles",
    [WEEK_DAYS.Thursday]: "Jueves",
    [WEEK_DAYS.Friday]: "Viernes",
    [WEEK_DAYS.Saturday]: "Sábado",
    [WEEK_DAYS.Sunday]: "Domingo"
  },
  openStatusTypes: {
    [OPEN_STATUS.ANY]: "Cualquiera",
    [OPEN_STATUS.OPEN]: "Abrir",
    [OPEN_STATUS.CLOSED_PERMANENTLY]: "Cerrado permanentemente",
    [OPEN_STATUS.CLOSED_TEMPORARILY]: "Cerrado temporalmente"
  },
  facilityStatusTypes: {
    [FACILITY_STATUS.ANY]: "Cualquiera",
    [FACILITY_STATUS.IS_VERIFIED]: "Verificado",
    [FACILITY_STATUS.IS_UNVERIFIED]: "No verificado",
    [FACILITY_STATUS.IS_DUPLICATE]: "Duplicado",
    [FACILITY_STATUS.HAS_PENDING_VERIFICATION]: "Verificación pendiente",
    [FACILITY_STATUS.IS_INACTIVE]: "Sin conexión"
  },
  bingFacilityStatusTypes: {
    [BING_FACILITY_STATUS.ANY]: "Cualquiera",
    [BING_FACILITY_STATUS.NO_CONNECTION]: "Sin conexión",
    [BING_FACILITY_STATUS.CONNECTION_ACTIVE]: "Conexión está activa",
    [BING_FACILITY_STATUS.PUBLISHING_IN_PROGRESS]: "Publicación en progreso",
    [BING_FACILITY_STATUS.PUBLISHING_FAILED]: "Error al publicar la información"
  },
  externalChangesSources: {
    [EXTERNAL_CHANGES_SOURCE.GMB]: "Google Business Profile Manager",
    [EXTERNAL_CHANGES_SOURCE.EXTERNAL]: "Cambio externo"
  },
  externalChangesTypes: {
    [EXTERNAL_CHANGES_TYPE.ADDITION]: "Adición",
    [EXTERNAL_CHANGES_TYPE.REMOVAL]: "Eliminación",
    [EXTERNAL_CHANGES_TYPE.CHANGE]: "Cambiar"
  },
  externalChangesStatuses: {
    [EXTERNAL_CHANGES_STATUS.PENDING]: "Pendiente",
    [EXTERNAL_CHANGES_STATUS.ACCEPTED]: "Aceptado",
    [EXTERNAL_CHANGES_STATUS.REJECTED]: "Rechazado",
    [EXTERNAL_CHANGES_STATUS.DELETED_DUE_TO_GMB]: "Eliminado a través de GMB",
    [EXTERNAL_CHANGES_STATUS.DELETED_DUE_TO_CENTER]:
      "Eliminado a través de Center"
  },
  facilitiesSortingOptions: {
    [FACILITIES_SORTING_OPTION.DEFAULT]: "Predeterminado",
    [FACILITIES_SORTING_OPTION.COUNTRY]: "País A-Z",
    [FACILITIES_SORTING_OPTION.CITY]: "Ciudad A-Z",
    [FACILITIES_SORTING_OPTION.STORE_CODE]: "Código de tienda"
  },
  topChartSeries: {
    [TOP_CHART_SERIE.TOP_3]: "Posiciones 1-3",
    [TOP_CHART_SERIE.TOP_10]: "Posiciones 4-10",
    [TOP_CHART_SERIE.TOP_20]: "Posiciones 11-20"
  },
  reviewsTagsSearchTypes: {
    [REVIEWS_TAGS_SEARCH_TYPE.INCLUDE_ALL_TAGS]:
      "con todas las categorías elegidas",
    [REVIEWS_TAGS_SEARCH_TYPE.INCLUDE_ANY_TAG]:
      "con cualquiera de las categorías elegidas",
    noCategories: "sin categorías"
  },

  gmbVerification: {
    name:
      "Cuando cambias el nombre, en algunos casos Google podría solicitar la reverificación de tu ficha. Para minimizar tal posibilidad, recuerda: el nombre de tu ficha debe ser el mismo que el nombre de tu empresa. No debe contener el nombre de la ciudad, frases de marketing o palabras clave para SEO.",
    category:
      'Google podría solicitar la verificación de tu ubicación cuando agregues o edites categorías de negocios. Para evitar este tipo de preguntas, asegúrate de que las categorías de tu negocio describan qué es tu negocio, no el tipo de servicios que ofrece (por ejemplo, elige "Entrega de pizza" en lugar de "Restaurante para llevar").',
    dialog: {
      title: "Advertencia",
      body:
        "Estás actualizando campos ({fields}). Cuando edites estos campos, en algunos casos, Google podría solicitar la reverificación de tu listado.\n\nLee las instrucciones a continuación para asegurarte de que tus actualizaciones estén de acuerdo con las directrices de Google.",
      confirm: "Confirmar y continuar."
    },
    changes: {
      name: {
        label: "Nombre",
        description:
          "El nombre del listado debe ser el mismo que el nombre de tu empresa. No debe contener el nombre de la ciudad, frases de marketing o palabras clave para SEO."
      },
      address: {
        label: "Dirección",
        description:
          "Utiliza una dirección precisa y completa para describir la ubicación de tu propiedad. No incluyas en la dirección información que no esté relacionada con la ubicación física de tu propiedad (por ejemplo, URL, palabras clave para SEO)."
      },
      category: {
        label: "Categorías de negocios",
        description:
          'Las categorías de negocios deben describir qué es tu empresa, no qué servicios o productos ofrece. Elige categorías que sean lo más específicas posible, pero que representen tu negocio principal (por ejemplo, elige "Reparto de pizzas" en lugar de "Restaurante para llevar").'
      }
    }
  },

  questionsAndAnswers: {
    expandAnswers: "Expandir respuestas ({0})",
    deleteItemTitle: "¿Estás seguro de querer eliminar este elemento?",
    collapseAnswers: "Colapsar respuestas",
    selectLocation: "Seleccionar ubicación",
    questionAndAnswer: "Preguntas y Respuestas",
    title: "Lista de Preguntas y Respuestas",
    sharingPubliclyOnGoogle: "Estás compartiendo públicamente en Google",
    askQuestion: "Agregar una pregunta",
    publishAnswer: "Publicar respuesta",
    owner: "Propietario",
    tabs: {
      all: "Todos",
      withoutAnswer: "Sin responder",
      withAnswer: "Respondidas"
    },
    noDataDescription:
      "No hay preguntas ni respuestas que coincidan con los criterios seleccionados."
  },

  reviewBooster: {
    additionalQuestions: "Preguntas adicionales",
    title: "Configuración de Review Booster",
    changeBlocked: "Cambio ha sido bloqueado",
    placeholder: {
      contactText: "Damian te contará más sobre Review Booster:",

      positiveScreenList: {
        title: "Dos caminos de revisión - positivo",
        firstElement:
          "Se les pide a los clientes que califiquen su experiencia de compra en una ubicación determinada.",
        secondElement:
          "Una vez que se publica la calificación, los clientes reciben una nota de agradecimiento y se les invita a dejar una reseña en Google Maps.",
        thirdElement:
          "Finalmente, los clientes reciben una nota de agradecimiento por la reseña publicada."
      },
      negativeScreenList: {
        title: "Dos caminos de revisión - negativo",
        firstElement:
          "Se solicita a los clientes que califiquen su experiencia de compra en una ubicación determinada.",
        secondElement:
          "Si la calificación es negativa, se les pide a los clientes que publiquen una reseña.",
        thirdElement:
          "Finalmente, los clientes reciben una nota de agradecimiento por la reseña publicada."
      },

      list: {
        title: "Dos caminos de revisión - positivo",
        firstElement: {
          title: "Comprende mejor a tus clientes",
          description:
            "Comprende claramente a tus clientes. Al recopilar y analizar las reseñas de los clientes, puedes entender mejor las necesidades de tus clientes. Y luego, puedes utilizar este conocimiento para mejorar y enriquecer su experiencia de compra."
        },
        secondElement: {
          title: "Mejora tus calificaciones y reseñas en Google Maps",
          description:
            "Con más del 93% de los clientes admitiendo que leen reseñas en línea antes de realizar una compra, las calificaciones mejoradas seguramente influirán en las decisiones de compra, así como también alentará a los clientes a compartir su experiencia con otros (solo el 47% de los clientes comparte sus experiencias positivas, en comparación con el 97% que decide compartir sus experiencias negativas)."
        },
        thirdElement: {
          title: "Aumenta el tráfico en la tienda y mejora tus ganancias",
          description:
            "Las investigaciones muestran que el 89% de los clientes tienen más probabilidades de realizar otra compra una vez que la tienda responde a su reseña. Los datos confirman que, en promedio, las reseñas pueden generar un aumento del 18% en las ventas."
        }
      },
      subtitle: "¿Por qué Local Review Booster?"
    },
    formList: {
      title: "Formularios",
      formLink: "Formular formularios",
      description:
        "Aquí hay una lista de todos los formularios activos para recopilar comentarios y reseñas. Para cada uno, puedes descargar enlaces para ubicaciones individuales así como estadísticas (información sobre cómo los usuarios utilizaron los formularios)."
    },
    reviews: {
      title: "Respuestas de formularios",
      selectForm: "Seleccionar formulario",
      googleMapsClicked: "El cliente se trasladó a Google Maps",
      googleMapsClickedAndReviewAdded:
        "El cliente fue a Google Maps y agregó una reseña.",
      aiGenerated:
        "El usuario utilizó el asistente de inteligencia artificial para ayudar a redactar una reseña.",
      noData:
        "No hay datos disponibles. Seleccione un rango de fechas diferente o modifique los filtros."
    }
  },
  storeLocator: {
    general: "General",
    faqTitle: "FAQ",
    faqSubtitle:
      "Vista previa de preguntas frecuentes y respuestas para este negocio",
    configSubtitle: "Información adicional para el Localizador de Tiendas",
    contactAndSectionsTitle: "Contacto y secciones adicionales",
    contactAndSectionsDescription: `Crea secciones adicionales en el Localizador de Tiendas como: lista de enlaces,
          lista de texto con viñetas, sección de botones, sección de imágenes.`,
    faqItemTitle: "Preguntas frecuentes",
    backToStoreLocator: "Volver al Localizador de Tiendas",
    faqItemDescription:
      "Crea una lista de preguntas y respuestas a las preguntas más frecuentes de tus clientes.",
    faq: {
      noFaq: "No hay preguntas y respuestas",
      toAllLocations: "Para todas las ubicaciones",
      toLocation: "Para esta ubicación",
      faqCreatorTitle: "Creador de FAQ",
      addFaqToFacilities: "Añadir FAQ a sus fichas de empresa",
      question: "Pregunta",
      answer: "Respuesta",
      orderInfoText:
        "Las preguntas en el Localizador de tiendas se mostrarán según el orden a continuación.",
      allFacilities: "Todas las ubicaciones",
      editTitle: "Editar",
      changeOrder: "Cambiar orden",
      deleteAlertTitle: "¿Está seguro que desea eliminar esta pregunta?"
    },
    placeholder: {
      title:
        "Optimiza tu sitio web y aumenta la conversión a visitas a la tienda con el localizador de tiendas.",
      subtitle: "¿Por qué un Localizador de Tiendas?",
      implementedIn: "Consulta el localizador de tiendas de nuestro cliente:",
      contactText: "Damian te contará más sobre Store Locator.",
      phone: "+48 537 340 555",
      consultantName: "Damian Kordyla",
      list: {
        firstElement: {
          title:
            "Mejora la visibilidad en línea de tus tiendas en las búsquedas de Google",
          description:
            "El Localizador de Tiendas está optimizado para los motores de búsqueda (SEO), lo que facilita que se encuentren tus tiendas en los resultados de búsqueda. El sitio web de cada tienda se verá con más frecuencia, lo que incrementará el tráfico en línea, así como el tráfico en la tienda."
        },
        secondElement: {
          title: "Aumentar el tráfico en la tienda",
          description:
            "Gracias a nuestra solución, la página web de cada tienda obtendrá contenido adicional, como imágenes, información sobre nuevas y especiales ofertas, las mejores reseñas de clientes y las calificaciones más altas, convirtiendo las tasas de conversión en visitas reales a la tienda."
        },
        thirdElement: {
          title: "Ahorrar tiempo",
          description:
            "Store Locator te permite gestionar la información tanto en tus Google Maps Business Profiles como en tu propio sitio web simultáneamente, lo que ayuda a ahorrar tiempo."
        },
        fourthElement: {
          title: "Fácil de integrar y personalizar",
          description:
            "La solución puede adaptarse a la estética de tu negocio (esquema de colores, fuentes, logotipos) para convertirse en una parte integral de tu propio sitio web. Además, cualquier ajuste técnico es increíblemente fácil y rápido, y toma apenas una hora."
        }
      }
    },
    title: "Configuración del Localizador de Tiendas",
    saveChanges: "Guardar cambios",
    enableLocator: "¿Desea habilitar el Localizador de Tiendas?",
    contactUs: "¡Contáctanos!",
    basic: {
      title: "General",
      url: "URL",
      urlText: "Nombre de URL",
      name: "Nombre en el encabezado",
      addLogo: "Agregar un logotipo",
      primaryColor: "Color primario",
      selectPrimaryColor: "Selecciona el color primario",
      favoritesIcon: "Icono de favoritos"
    },
    facilities: {
      title: "Ubicaciones",
      show: "Mostrar",
      allFacilities: "Todas las ubicaciones ({0})",
      selectedGroups: "Grupos seleccionados",
      searchArea: "Área de búsqueda"
    },
    floatingButton: {
      text: "Texto",
      title: "Configuración adicional",
      subtitle: "Botón adicional visible en cada página:"
    },
    reviews: {
      title: "Reseñas",
      description:
        "Las reseñas del Localizador de tiendas se muestran de las más nuevas a las más antiguas. Además, puedes filtrar las reseñas para que se muestren solo aquellas con calificaciones específicas.",
      selectRatings: "Selecciona las calificaciones para mostrar",
      onlyWithText: "Reseñas solo con texto"
    },
    posts: {
      title: "Publicaciones",
      description:
        "Las publicaciones mostradas en Store Locator se pueden seleccionar en {0}.",
      descriptionLink: "lista de publicaciones"
    },
    photos: {
      title: "Fotos",
      description:
        "Las fotos mostradas en el Localizador de Tiendas pueden ser seleccionadas en {0}.",
      descriptionLink: "lista de fotos"
    },
    saveSuccess:
      "Cambios guardados. Los cambios aparecerán en Store Locator dentro de 10 minutos.",
    extraInfo: {
      pageTitle: "Localizador de tiendas",
      title: "Contacto y secciones adicionales",
      offerLink: "Enlace de oferta de la tienda",
      contact: "Contacto",
      sections: "Secciones",
      sectionName: "Nombre de la sección (opcional)",
      addNewElement: "Agregar otro",
      removeElement: "Eliminar la última fila",
      moveSection: "Mover sección:",
      selectSectionType: "Seleccionar tipo de sección",
      noSections: "Aún no tienes secciones adicionales.",
      linkSection: {
        defaultTitle: "Sección de enlaces",
        titleAdd: "Añadir enlaces",
        titleEdit: "Editar enlaces",
        label: "Lista de enlaces",
        description:
          "Proporcione un nombre de enlace que se mostrará a los clientes en la página del Localizador de Tiendas y luego ingrese la URL a la que debemos redirigir.",
        columns: {
          text: "Nombre de URL",
          url: "Dirección URL"
        }
      }
    }
  },
  usersBehavior: {
    lastDaysLabel: "¿Por qué no puedo seleccionar las últimas dos semanas?",
    lastDaysTooltip:
      "Google pone a disposición los datos completos con un retraso. Debido a que queremos asegurar conclusiones correctas basadas en datos completos, hemos hecho imposible seleccionar las dos últimas semanas."
  },
  offer: {
    showCouponInShop: "Mostrar cupón en tienda",
    offerValid: "Oferta válida",
    useOnline: "Utilizar en línea",
    terms: "Términos de uso"
  },
  asyncCSVExport: {
    title: "Exportando archivo",
    content1:
      "El archivo se está generando. Puedes cerrar la ventana o esperar.",
    content2:
      "Una vez que se complete la generación, recibirás un correo electrónico con el archivo.",
    download: "Descargar archivo",
    generatingInProgress: "Generación de archivo en progreso",
    fileGeneratingError: "Error de generación de archivo",
    closeWindow: "Cerrar ventana"
  },
  notes: {
    note: "Nota",
    addNote: "Agregar nota",
    deleteNote: "Eliminar",
    deleteNoteDescription: "¿Realmente deseas eliminar esta nota de reseña?",
    noteAdded: "Nota añadida",
    noteDeleted: "Nota eliminada",
    noteUpdated: "Nota actualizada"
  },
  sentiment: {
    reviewsProcessing: "Procesamiento de reseñas",
    reviewsProcessingNumber: "Número de reseñas en proceso",
    reviewsProcessingNumber2: "Algunas reseñas están siendo procesadas.",
    reviewsProcessingNumber3:
      "La revisión se está procesando actualmente para asignar automáticamente categorías con sentimientos. Durante este proceso, las categorías y los sentimientos no se pueden editar manualmente.",
    inProgressAlert:
      "El procesamiento de <strong>{0} categorías</strong> está en curso.",
    unknown: "Desconocido",
    markAsPositive: "Marcar como positivo",
    markAsNegative: "Marcar como negativo",
    markAsNeutral: "Marcar como neutral",
    clearSelection: "Borrar selección",
    sentimentName: "Sentimiento",
    positive: "Positivo",
    negative: "Negativo",
    neutral: "Neutral",
    unassigned: "No asignado",
    mixed: "Mixto",
    heatmap: {
      legendTitle: "Sentimiento en mayoría",
      mostly: "Mayormente",
      tooltipClickInfo: "Haz clic en el campo para ver más"
    }
  },
  mapIntegrations: {
    noFacilities: {
      button: "Agregar cuenta",
      title: "Enviar información de ubicación a múltiples destinos",
      desc:
        "Aquí puedes habilitar fácilmente la integración con varios mapas. Esto enviará automáticamente información sobre tus ubicaciones a ellos. Para hacer esto posible, importa tus listados añadiendo una cuenta de Google."
    },
    catalog: "Catálogo",
    integrationStatus: "Estado de integración",
    additionalInfo: "Información adicional",
    actions: "Acciones",
    enable: "Habilitar",
    disable: "Desactivar",
    mapConfigurationTitle: "Configuración del mapa",
    infoText: "Lorem ipsum dolor sit amet...",
    bing: {
      dialog: {
        enable: {
          title: "¿Habilitar la integración con Bing Maps?",
          description: `Después de habilitar la integración, la información seleccionada sobre todas sus ubicaciones actuales y futuras se enviará automáticamente a Bing Maps. Sus ubicaciones que no están presentes en Bing Maps se crearán allí (a veces esto puede tardar hasta 10 días debido a la forma en que Bing Maps opera). ¿Desea continuar?`
        },
        disable: {
          title: "Deshabilitar la integración con Bing Maps?",
          description: `Desde el momento en que la integración se desactiva, no se enviarán nuevos cambios de las ubicaciones a Bing Maps. ¿Quieres continuar?`
        }
      }
    }
  },
  facebook: {
    removePageAndFacilities: "Eliminar página e instalaciones",
    noConnectedFacebookAccount:
      "No hay una cuenta de Facebook conectada, por favor inicia sesión con Facebook para añadir.",
    addPage: "Agregar página",
    facebookAccounts: "Cuentas de Facebook",
    loginWithFacebook: "Inicia sesión con Facebook",
    info1:
      "Para enviar información de ubicación desde Center AI a las tarjetas de presentación de Facebook, necesitas agregar una cuenta de Facebook y seleccionar las páginas que contienen las tarjetas de presentación.",
    info2:
      "Se requiere que las páginas de Facebook tengan la estructura adecuada: todas las tarjetas de presentación deben añadirse como Páginas de Ubicación dentro de la página.",
    accountRemoveAlert: {
      title: "Confirmar la desconexión de la cuenta",
      description:
        "Después de desconectarse, Center AI perderá acceso a las tarjetas de visita de esta cuenta.<br /> La información de Center AI dejará de enviarse a estas tarjetas de visita."
    },
    pageRemoveAlert: {
      title: "Confirma la desconexión de la página y sus tarjetas de negocio.",
      description:
        "Después de desconectarse, Center AI perderá acceso a las tarjetas de presentación de esta página. La información de Center AI dejará de enviarse a estas tarjetas de presentación."
    },
    enableIntegrationAlert: {
      title: "Se han añadido páginas",
      description: `Ha comenzado la integración con Facebook para las tarjetas de visita de páginas seleccionadas. Para completar este proceso necesitaremos información adicional de usted. Nos pondremos en contacto con usted dentro de X días. Puede monitorear el estado del proceso en la pantalla de <b>"Configuración del mapa"</b>.`
    },
    selectPageDialog: {
      title: "Seleccionar páginas con tarjetas de presentación",
      description: `Elige las páginas con tarjetas de presentación que deseas conectar con ubicaciones en Center AI. Después de seleccionarlas, empezaremos el proceso de emparejar tarjetas de presentación de Facebook con ubicaciones en Center AI. <br /> <br /> Las tarjetas de presentación emparejadas se actualizarán con información de Center AI.`,
      infobox: `Este proceso puede requerir su participación. Si es necesario, nuestro departamento de soporte se pondrá en contacto con usted. Puede monitorear el estado del proceso en la pantalla de 'Configuración de Mapa'.`,
      confirmAndStartIntegration: "Confirma y comienza la integración."
    },
    noPagesToAdd: "No hay páginas para añadir",
    goToMapConfiguration: "Ir a la configuración del mapa",
    goBackToMapConfiguration: "Volver a la configuración del mapa",
    completeConfiguration: "Configuración completa",
    configurationInProgress: "Configuración en progreso",
    configureAlert: {
      title: "Configurar cuenta de Facebook",
      description:
        "Para habilitar la integración, primero debes configurar tu cuenta de Facebook.",
      confirmLabel: "Configurar cuenta"
    }
  },
  mobile: {
    common: {
      addApp: "Agregar aplicación",
      appConfiguration: "Configuración de la aplicación",
      cancel: "Cancelar",
      noApps: "Sin aplicaciones",
      appDeleteAlert: {
        btnText: "Eliminar",
        title: "Confirmar eliminación de la aplicación",
        description: "¿Está seguro de que desea eliminar la aplicación?"
      }
    },
    googlePlay: {
      listings: {
        subtitle: {
          mainSection: "Cuentas de Google Play añadidas"
        },
        accountRemoveAlert: {
          title: "Confirmar desconexión de cuenta",
          description:
            "Después de desconectarse, Center AI perderá acceso a las aplicaciones relacionadas con esta cuenta.<br /> La información de Center AI dejará de ser enviada a estas aplicaciones."
        },
        appAddForm: {
          appName: "Nombre de la aplicación",
          googlePlayUrl: "Google Play URL"
        },
        info:
          "Para habilitar la integración, primero debes configurar tu cuenta de Google Play."
      },
      name: "Google Play"
    }
  },
  payments: {
    activeSubscriptionDescription:
      "Tu suscripción está activa. Administra tu plan o liquida cualquier factura pendiente a continuación.",
    freePlanDescription:
      "Tu prueba gratuita incluye acceso completo a todas las funciones del <b>Plan Estándar</b>. Selecciona un plan para continuar después del período de prueba.",
    selectPlanButton: "Seleccionar plan",
    subscriptionExpiryDate: "Fecha de vencimiento de la suscripción: {date}",
    paymentSummary: "Resumen de pago",
    vatNumberRetrievalTooltip:
      "La recuperación de datos solo está disponible para números de NIP polacos válidos.",
    paymentMethod: "Opciones de Pago",
    limit: "Límite",
    aboveLimit: "por encima del límite",
    currently: "Actualmente",
    overLimit: "Límites excedidos",
    usageLimits: "Límites superados",
    viewUsageLimits: "Ver límites",
    limitDescriptionNoDeletion: `Este plan, en comparación con tu plan actual, tiene restricciones adicionales (límites) que actualmente se superan. Para cambiar a este plan, primero elimina los objetos en exceso que están causando las superaciones de los límites en el panel de AI Center.`,
    limitDescription: `Este plan, en comparación con tu plan actual, tiene restricciones adicionales (límites) que actualmente se superan. Para cambiar a este plan, primero elimina los objetos excedentes que causan los excesos de límites. Haz clic en el límite excedido para abrir un menú desplegable donde puedes eliminar los objetos excedentes.`,
    limits: {
      max_facilities: "Número de ubicaciones",
      max_maps_keywords: "Número de palabras clave monitoreadas",
      max_ai_categorization_categories: "Número de categorías de reseñas",
      max_company_users: "Número de usuarios",
      max_listings_competitors: "Número de ubicaciones de competidores",
      max_websites: "Máximo de sitios web",
      max_organic_keywords: "Máximo de palabras clave orgánicas",
      max_search_locations: "Máxima Ubicación de Búsqueda",
      max_website_competitors: "Máximos Competidores de Sitios Web"
    },
    changePlanHelp:
      "Si deseas cambiar a un plan diferente, comunícate con nosotros enviando un correo electrónico a support@center.ai o llamando al 537 340 555.",
    freeTrialPeriod: "prueba gratuita",
    daysLeft: "Termina en {0} días",
    freeTrialTooltip:
      "Ve a la configuración de suscripciones para seleccionar un plan",
    freeTrialEndsIn: "La prueba gratuita termina el: {0}",
    freeTrialEnded: "La prueba gratuita ha finalizado",
    freeTrial: "Prueba gratuita",
    title: "Suscripción",
    orderDetails: "Plan seleccionado",
    locationsQuantity: "Número de ubicaciones",
    payByCard: "Pagar con tarjeta",
    payByQuickPayment: "Pagos Rápidos",
    totalPrice: "Precio total",
    perLocation: "{0} neto por ubicación mensualmente",
    monthly: "Mensualmente",
    annually: "Anualmente",
    payMonthly: "Pago mensual",
    payAnnually: "Pago anual",
    payNow: "Pagar ahora",
    paymentDetails: "Complete tus datos y confirma el pago",
    selectedPlan: "Planes",
    completeYourPayment: "Complete tu pago",
    processingPayment: "Procesando pago",
    status: {
      success: "¡Todo está listo!",
      pending: "Tu pago está siendo procesado.",
      failed: "Pago fallido"
    },
    startUsingCenterAi: "Ir a la aplicación",
    goBackToPayment: "Regresar al pago",
    error: "Se produjo un error al procesar el pago.",
    accept: "Acepto el",
    paymentsRegulations: "términos de uso",
    promoCode: "Código de promoción",
    promoCodeText:
      "El código de promoción se puede agregar en el siguiente paso.",
    invoiceData: "Añade tu información de facturación",
    invoiceDataDescription:
      "Hazlo fácil: simplemente ingresa tu ID de IVA, y completaremos automáticamente los datos de tu empresa.",
    getData: "Obtener datos",
    net: "red",
    vat: "IVA",
    pln: "PLN",
    planDialog: {
      title: "¡Casi allí!",
      description: `Hemos abierto la página de gestión de suscripciones en una nueva pestaña para ti. Después de completar tus cambios allí, vuelve aquí y haz clic en el botón de actualizar para ver tu suscripción actualizada.`
    },
    paymentErrorDescription: `No pudimos procesar tu pago. Esto podría deberse a una de las siguientes razones:

<br />
<br />
<ul>
<li>Fondos insuficientes en tu cuenta.</li>
<li>Detalles incorrectos de la tarjeta (por ejemplo, número, fecha de vencimiento, código CVV).</li>
<li>Problemas de autorización con tu banco.</li>
</ul>
<br />

Por favor, intenta de nuevo o contacta a tu banco para resolver el problema.`,
    paymentSuccessDescription: `Tu pago se procesó con éxito. Hemos enviado tu factura a tu correo electrónico. En el futuro, recibirás automáticamente las facturas por cualquier pago. Puedes encontrar el historial completo de facturas en la sección "User Account" de tu panel de control de Center AI.`
  },
  apple: {
    apple: "Apple",
    title: "Cuentas de Apple",
    loginWithApple: "Iniciar sesión con Apple",
    emptyState: {
      title: "No hay cuentas de Apple Maps conectadas.",
      description:
        "Conecta tu cuenta de Apple Maps para gestionar ubicaciones de negocios en Apple Maps."
    },
    header: {
      title: "Cuentas conectadas"
    },
    info1:
      "Para enviar información de ubicación desde Center AI a las tarjetas de negocios de Apple Maps, necesitas añadir una cuenta de Apple.",
    configureAlert: {
      title: "Configurar Cuenta de Apple",
      description:
        "Para habilitar la integración, primero debe configurar su cuenta de Apple.",
      confirmLabel: "Configurar Cuenta"
    }
  }
};
